import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import createInfo from "./Purchase.module.css";
import StyleInfo from "../../BookModule.module.css";
import ListInfo from "../../BookModule.module.css";
import Select, { components } from "react-select";
import { Search } from "@mui/icons-material";
import toast from "react-hot-toast";
import moment from "moment";
import ViewIcon from "./ViewIcon.png";
import { AxiosInstance } from "../../../../../../axios";
import Loader from "../../../../Loader";
import { Chip, Paper, styled } from "@mui/material";
import { R_PER_PAGE } from "../../../../../../labels";
import Pagination from "../../../../../ReusuableComponent/Pagination/Pagination";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  setBookFilters,
  setFilters,
} from "../../../../../../redux/purchaseBookFilterSlice";

export default function PurchsaeInfoCreate() {
  const { id } = useParams();
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  let staffLocId;
  let user_type = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
      user_type = user.user_type;
    }
    staffLocId = user.staff_loc_id;
  } else {
    console.log("User Id cannot be available in session storage");
  }

  const { pathname } = useLocation();

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
  }, [pathname]);
  let page = R_PER_PAGE;

  const navigate = useNavigate();
  const [CourierCharges, setCourierCharges] = useState(0);
  const [medium_on, setMedium_on] = useState([]);
  const [sortOrder, setSortOrder] = useState("asc");
  const [author_name, setAuthor_name] = useState([]);
  const [publisher_name, setPublisher_name] = useState([]);
  const [category_on, setCategory_on] = useState([]);
  const [course_on, setCourse_on] = useState([]);
  const [subject_on, setSubject_on] = useState([]);
  const [searchTerm, setSearchTerm] = useState(""); // For manual search
  const [courseIds, setCourseIds] = useState([]);
  const [courseId, setCourseId] = useState([]);
  const [subjectId, setSubjectId] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [originalListData, setOriginalListData] = useState();
  const [userAddresses, setUserAddresses] = useState([]); // Store multiple users
  const [isNewUser, setIsNewUser] = useState(false); // Flag for new user
  const [selectedAddress, setSelectedAddress] = useState("");
  const [series_on, setSeries_on] = useState([]);
  const [selectedBooks, setSelectedBooks] = useState([]);
  const [allBookList, setAllBookList] = useState([]);
  const [userCheckUserId, setUserCheckUserId] = useState();

  const [isQuantityDisabled, setIsQuantityDisabled] = useState({});

  const [items, setItems] = useState([]);
  const allAreEbooks = items.every((item) => item.is_ebook === 1);

  const [currentPage, setCurrentPage] = useState(1);
  const [categoryId, setCategoryId] = useState([]);
  const [visible_to_user, setVisible_to_user] = useState([]);
  const [availableToUser, setavailableToUser] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [updateListData, setUpdateListData] = useState();

  const [subjectIds, setSubjectIds] = useState([]);

  const [error, setError] = useState({});
  const [updateChipData, setUpdateChipData] = useState([]);
  const [branchdelivery, setBranchdelivery] = useState([]);
  const [originalBranches, setOriginalBranches] = useState([]);
  const [open, setOpen] = useState(false);
  const [isEditopen, setisEditopen] = useState(false);
  const [delivery, setDelivery] = useState([]);
  const [checkUserStatus, setCheckUserStatus] = useState(true);
  const [userBatch, setUserBatch] = useState([]);
  const [freeStatus, setFreeStatus] = useState([]);

  const [selectedUserBatch, setSelectedUserBatch] = useState(null);

  const [message, setMessage] = useState("");

  const [rewardMessage, setRewardMessage] = useState("");

  const [rewardAmount, setRewardAmount] = useState(0);
  const [listErrors, setListErrors] = useState({});

  const [couponApplied, setCouponApplied] = useState({
    status: false,
    amount: 0,
    coupon_code: "",
  });

  const [rewardsnApplied, setRewardsApplied] = useState({
    status: false,
    amount: 0,
    rewardPoints: "",
  });
  const [userCheck, setUserCheck] = useState(false);
  const [statusCheck, setStatusCheck] = useState();
  const [rowsPerPageTwo, setRowsPerPageTwo] = useState(5);
  const [currentPageTwo, setCurrentPageTwo] = useState(1);
  const [selectedBookAndBookSetSort, setSelectedBookAndBookSetSort] =
    useState("asc");
  const [sortedBooks, setSortedBooks] = useState([]);
  const [paginatedBooks, setPaginatedBooks] = useState([]);
  const [eBook, setEBook] = useState([]);

  const [comboOffer, setComboOffer] = useState([]);
  const [freeBook, setFreeBook] = useState(0);
  const freeBook_ref = useRef(null);
  const payment_mode_ref = useRef(null);

  const filterRef_mrp = useRef(null);
  const [courierCharge, setCourierCharge] = useState(0);

  const [barcode, setBarcode] = useState("");
  const [mrp, setMrp] = useState({
    fromDate: "",
    toDate: "",
  });
  const [initialfields, setInitialfields] = useState({
    quantity: 1,
    freeBook: "no",
    your_price: 0,
    userName: "",
    emailId: "",
    phoneNumber: "",
    deliveryMode: 1,
    actualPrice: 0,
    specialOffer: 0,
    coupon_code: "",
    CouponAmount: 0,
    rewardPoints: "",
    rewardPointAmount: 0,
    totalDiscount: 0,
    CourierCharges: 0,
    netAmount: 0,
    name: "",
    address: "",
    pincode: "",
    EditId: "",
    newPhoneNumber: "",
    payment_mode: 0,
  });
  useEffect(() => {
    setSortedBooks([...allBookList]);
    setCurrentPageTwo(1);
  }, [allBookList]);

  const totalPagesTwo = Math.ceil(sortedBooks.length / rowsPerPageTwo);

  const startIndexOne = (currentPageTwo - 1) * rowsPerPageTwo;
  const endIndexOne = startIndexOne + rowsPerPageTwo;

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isCheckbox = event.target.closest('input[type="checkbox"]');
      const isApplyFilterButton = event.target.closest(".filterBoxs_testlist");
      const isChipData = event.target.closest(".paperil_global");
      if (isCheckbox || isApplyFilterButton || isChipData) return;
      if (
        filterRef_author.current &&
        !filterRef_author.current.contains(event.target)
      ) {
        {
          const hasAuthor = updateChipData.some(
            (chipItem) => chipItem.type === "author"
          );
          if (hasAuthor) {
            const updatedAuthor = updateChipData.filter(
              (chipItem) => chipItem.type === "author"
            );
            setAuthor_name(updatedAuthor);
          } else {
            setAuthor_name([]);
          }
          setIsOpen((prev) => ({ ...prev, author: false }));
        }
      }
      if (
        filterRef_mrp.current &&
        !filterRef_mrp.current.contains(event.target)
      ) {
        {
          const hasAuthor = updateChipData.some(
            (chipItem) => chipItem.type === "price"
          );
          if (hasAuthor) {
            const updatedPrice = updateChipData.filter(
              (chipItem) => chipItem.type === "price"
            );
            // alert("1")
            const [fromDate, toDate] = updatedPrice[0].name
              .split(" - ")
              .map((val) => val.trim());
            setMrp({ fromDate, toDate });
          } else {
            // alert("2")
            setMrp({ fromDate: "", toDate: "" });
          }
          setIsOpen((prev) => ({ ...prev, price: false }));
        }
      }

      if (
        filterRef_publisher.current &&
        !filterRef_publisher.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "publisher"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "publisher"
            );
            setPublisher_name(updatedCategory);
          } else {
            setPublisher_name([]);
          }
          setIsOpen((prev) => ({ ...prev, publisher: false }));
        }
      }
      if (
        filterRef_visible_to_user.current &&
        !filterRef_visible_to_user.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "visible_to_user"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "visible_to_user"
            );
            setVisible_to_user(updatedCategory);
          } else {
            setVisible_to_user([]);
          }
          setIsOpen((prev) => ({ ...prev, visible_to_user: false }));
        }
      }
      if (
        filterRef_category.current &&
        !filterRef_category.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "category"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "category"
            );
            setCategory_on(updatedCategory);
          } else {
            setCategory_on([]);
          }
          setIsOpen((prev) => ({ ...prev, category: false }));
        }
      }
      if (
        filterRef_course.current &&
        !filterRef_course.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "course"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "course"
            );
            setCourse_on(updatedCategory);
          } else {
            setCourse_on([]);
          }
          setIsOpen((prev) => ({ ...prev, course: false }));
        }
      }
      if (
        filterRef_subject.current &&
        !filterRef_subject.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "subject"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "subject"
            );
            setSubject_on(updatedCategory);
          } else {
            setSubject_on([]);
          }
          setIsOpen((prev) => ({ ...prev, subject: false }));
        }
      }
      if (
        filterRef_medium.current &&
        !filterRef_medium.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "medium"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "medium"
            );
            setMedium_on(updatedCategory);
          } else {
            setMedium_on([]);
          }
          setIsOpen((prev) => ({ ...prev, medium: false }));
        }
      }
      if (
        filterRef_series.current &&
        !filterRef_series.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "seriesTag"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "seriesTag"
            );
            setSeries_on(updatedCategory);
          } else {
            setSeries_on([]);
          }
          setIsOpen((prev) => ({ ...prev, seriesTag: false }));
        }
      }
      if (
        filterRef_ebook.current &&
        !filterRef_ebook.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "eBook"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "eBook"
            );
            setEBook(updatedCategory);
          } else {
            setEBook([]);
          }
          setIsOpen((prev) => ({ ...prev, is_ebook: false }));
        }
      }

      if (
        filterRef_avaliable_to_user.current &&
        !filterRef_avaliable_to_user.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "availableToUser"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "availableToUser"
            );
            setavailableToUser(updatedCategory);
          } else {
            setavailableToUser([]);
          }
          setIsOpen((prev) => ({ ...prev, availableToUser: false }));
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [
    updateChipData,
    author_name,
    publisher_name,
    series_on,
    visible_to_user,
    category_on,
    course_on,
    subject_on,
    medium_on,
    eBook,
    freeBook,
    initialfields,
  ]);

  useEffect(() => {
    setPaginatedBooks(sortedBooks.slice(startIndexOne, endIndexOne));
  }, [
    sortedBooks,
    currentPageTwo,
    rowsPerPageTwo,
    startIndexOne,
    endIndexOne,
    mrp,
  ]);

  const handlePageCountTwo = (e) => {
    const newRowsPerPage = Number(e.target.value);
    setRowsPerPageTwo(newRowsPerPage);
    setCurrentPageTwo(1);
  };

  const handlePrevTwo = () => {
    setCurrentPageTwo((prev) => Math.max(prev - 1, 1));
  };

  const handleNextTwo = () => {
    setCurrentPageTwo((prev) => Math.min(prev + 1, totalPagesTwo));
  };

  const SortSelectedBooksAndBookSet = (event, sortKey) => {
    event.preventDefault();

    const order = selectedBookAndBookSetSort === "asc" ? "desc" : "asc";
    setSelectedBookAndBookSetSort(order);

    const sortedList = [...sortedBooks].sort((a, b) => {
      if (a[sortKey] < b[sortKey]) return order === "asc" ? -1 : 1;
      if (a[sortKey] > b[sortKey]) return order === "asc" ? 1 : -1;
      return 0;
    });

    setSortedBooks(sortedList);
    setCurrentPageTwo(1);
  };

  const [activeTab, setActiveTab] = useState(0);

  const Tagsitems = [
    {
      tag_id: 0,
      tag_name: "A",
    },
    {
      tag_id: 1,
      tag_name: "B",
    },
    {
      tag_id: 2,
      tag_name: "GB",
    },
    {
      tag_id: 3,
      tag_name: "QB",
    },
    {
      tag_id: 4,
      tag_name: "PYQ",
    },
    // {
    //   tag_id: 6,
    //   tag_name: "Combo Offers",
    // },
  ];
  let filtervisible_to_user = [];
  let filterAvalible_to_user = [];
  let filterPublisher = [];
  let filterCourse = [];
  let filterSubject = [];
  let filterCategory = [];
  let filterAuthor = [];
  let filterMedium = [];
  let filterSeries = [];
  let filterEBook = [];
  let filterComboOffer = [];

  function updateStateData() {
    filterAuthor = author_name;
    filterPublisher = publisher_name;
    filtervisible_to_user = visible_to_user;
    filterAvalible_to_user = availableToUser;
    filterCategory = category_on;
    filterCourse = course_on;
    filterSubject = subject_on;
    filterMedium = medium_on;
    filterSeries = series_on;
    filterEBook = eBook;
    filterComboOffer = comboOffer;
  }

  const [isOpen, setIsOpen] = useState({
    author: false,
    publisher: false,
    visible_to_user: false,
    availableToUser: false,
    category: false,
    course: false,
    subject: false,
    medium: false,
    seriesTag: false,
    is_ebook: false,
    is_combo_offer: false,
    price: false,
  });

  const fillCheckbox = useSelector((state) => state.filterBooks?.fillCheckbox);
  const fillSelectBooks = useSelector(
    (state) => state.filterBooks?.fillSelectBooks
  );
  const filterBooksItems = useSelector(
    (state) => state.filterBooks?.filterBooksItems
  );
  const reduxUserEmail = useSelector((state) => state.filterBooks?.userEmail);
  const reduxUserNumber = useSelector((state) => state.filterBooks?.userNumber);
  const reduxItems = useSelector((state) => state.filterBooks?.items);
  const reduxFreeSales = useSelector((state) => state.filterBooks?.freeSales);

  useEffect(() => {
    if (filterBooksItems?.length > 0) {
      setItems(filterBooksItems);
    }
    if (fillSelectBooks?.length > 0) {
      setAllBookList(fillSelectBooks);
    }
    if (fillCheckbox?.length > 0) {
      setSelectedBooks(fillCheckbox);
    }
    if (reduxUserNumber?.length > 0) {
      setInitialfields((prev) => ({
        ...prev,
        phoneNumber: reduxUserNumber,
      }));
      handleCheckUser(reduxUserNumber);
    }
    if (reduxUserEmail?.length > 0) {
      setInitialfields((prev) => ({
        ...prev,
        emailId: reduxUserEmail,
      }));
    }
    if (reduxItems?.length > 0) {
      setItems(reduxItems);
    }
    if (reduxFreeSales === 0 || reduxFreeSales === 1) {
      setFreeBook(reduxFreeSales);
    }
  }, [
    filterBooksItems,
    fillSelectBooks,
    fillCheckbox,
    reduxUserNumber,
    reduxItems,
    reduxUserEmail,
    reduxFreeSales,
  ]);

  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));

  useEffect(() => {
    AxiosInstance.post("api/branch/list")
      .then((res) => {
        let branches = res.data.data.map((item) => ({
          id: item.id,
          name: item.name,
          phoneNumber: item.mobile_no,
          address: item.address,
          pincode: item.zipcode,
        }));

        if (staffLocId) {
          branches = branches.filter((item) => item.id === staffLocId);
        }
        setOriginalBranches(branches);
        setBranchdelivery(branches);
      })
      .catch((error) => {
        console.error("Error fetching branch list:", error);
      });
  }, [staffLocId]);

  const handleModelOpen = () => {
    setOpen(true);
    setisEditopen(false);
    setInitialfields((prevList) => ({
      ...prevList,
      name: "",
      newPhoneNumber: "",
      address: "",
      pincode: "",
    }));
  };
  const handleModelClose = () => {
    setOpen(false);
    setError({
      ...error,
      name: "",
      newPhoneNumber: "",
      address: "",
      pincode: "",
    });
  };

  const validateERRORDEFields = (name, newPhoneNumber, address, pincode) => {
    const errors = {};
    const phone = String(newPhoneNumber || "");
    if (!name.trim()) {
      errors.name = "Please enter the name";
    }

    if (!phone.trim()) {
      errors.newPhoneNumber = "Please enter the phone number";
    } else if (!/^\d{10}$/.test(newPhoneNumber)) {
      errors.newPhoneNumber = "Please enter a valid 10-digit number";
    }

    if (!address.trim()) {
      errors.address = "Please enter the address";
    }
    const pin =
      typeof pincode === "string" ? pincode.trim() : String(pincode).trim();
    if (!pin) {
      errors.pincode = "Please enter the pincode";
    } else if (!/^\d{6}$/.test(pincode)) {
      errors.pincode = "Please enter a valid 6-digit pincode";
    }

    return errors;
  };

  function getAPCSData(data) {
    if (data.length > 0) {
      const seenCourseIds = new Set();
      const seenSubjectIds = new Set();
      const courseKey =
        activeTab === 0 ? "group_course_id" : "group_course_name";
      const subjectKey = activeTab === 0 ? "subject_id" : "subject_name";
      const CourseDatas = data
        .filter((item) => {
          const key = item[courseKey];
          if (!key || seenCourseIds.has(key)) return false;
          seenCourseIds.add(key);
          return true;
        })
        .map((item) => ({
          course_name: item.group_course_name,
          course_id: item.group_course_id,
        }));

      setCourseId(CourseDatas);
      setCourseIds(CourseDatas);
      const SubjectDatas = data
        .filter((item) => {
          const key = item[subjectKey];
          if (!key || seenSubjectIds.has(key)) return false;
          seenSubjectIds.add(key);
          return true;
        })
        .map((item) => ({
          subject_name: item.subject_name,
          subject_id: item.subject_id,
        }));

      setSubjectId(SubjectDatas);
      setSubjectIds(SubjectDatas);
    }
  }
  useEffect(() => {
    AxiosInstance.get("api/course/category_list")
      .then((res) => {
        if (res.status === 200 && Array.isArray(res.data.data)) {
          setCategoryId(res.data.data);
        } else {
          setCategoryId([]);
        }
      })
      .catch((error) => {
        return error;
      });
  }, []);

  const isTriggeredRef = useRef(false);

  const handleFreeBookChange = async (event) => {
    isTriggeredRef.current = true; // Set flag before updating state
    const value = Number(event.target.value);
    // if (value === 0) {
    //   setBranchdelivery(originalBranches);
    //   setSelectedUserBatch(null);
    // }
    if (value === 1) {
      setInitialfields((prev) => ({
        ...prev,
        payment_mode: 3,
      }));
    } else {
      setInitialfields((prev) => ({
        ...prev,
        payment_mode: 0,
      }));
    }
    setError((e) => ({
      ...e,
      batchId: "",
    }));
    setFreeBook(value);
    // setSelectedAddress("");
    setPaginatedBooks([]);
    setSelectedBooks([]);
    setItems([]);
    setBarcode("");
    setAllBookList([]);
  };

  useEffect(() => {
    if (isTriggeredRef.current) {
      loadListdata();
      isTriggeredRef.current = false; // Reset flag after execution
    }
  }, [freeBook]);

  const filters = useSelector((state) => state.listBookFilter);
  const [isFiltersInitialized, setIsFiltersInitialized] = useState(false);

  useEffect(() => {
    // Ensure filters are set up before making API calls
    setAuthor_name(filters.author || []);
    setPublisher_name(filters.publisher || []);
    setVisible_to_user(filters.visibleToUser || []);
    setCategory_on(filters.category || []);
    setCourse_on(filters.course || []);
    setSubject_on(filters.subject || []);
    setMedium_on(filters.medium || []);
    setSeries_on(filters.seriesTag || []);
    setEBook(filters.eBook || []);
    setSearchTerm(filters.searchTerm || []);
    setMrp(filters.price || {});
    setActiveTab(filters.activeTab || 0);
    setIsFiltersInitialized(true); // Mark filters as initialized

    const allFilters = [
      ...(filters.author || []),
      ...(filters.publisher || []),
      ...(filters.visibleToUser || []),
      ...(filters.category || []),
      ...(filters.course || []),
      ...(filters.subject || []),
      ...(filters.medium || []),
      ...(filters.seriesTag || []),
      ...(filters.eBook || []),
      ...(filters.price?.fromDate && filters.price?.toDate
        ? [
            {
              name: `${filters.price.fromDate} - ${filters.price.toDate}`,
              type: "price",
            },
          ]
        : []),
      ...(typeof filters.searchTerm === "string" &&
      filters.searchTerm.trim() !== ""
        ? [{ name: filters.searchTerm, type: "search" }]
        : []),
    ];

    setUpdateChipData(allFilters);
  }, [filters]);
  const handlePriceChange = (event) => {
    let { name, value } = event.target;
    setMrp((prevFields) => ({
      ...prevFields,
      [name]: value,
    }));
  };
  useEffect(() => {
    if (
      isFiltersInitialized &&
      filters &&
      Object.keys(filters).some((key) => filters[key]?.length > 0)
    ) {
      loadListdata();
    }
  }, [
    JSON.stringify(filters),
    isFiltersInitialized,
    updateChipData,
    activeTab,
  ]);
  useEffect(() => {
    if (isFiltersInitialized && filters) {
      loadListdata();
    }
  }, [
    JSON.stringify(filters),
    isFiltersInitialized,
    updateChipData,
    activeTab,
  ]);

  function loadListdata() {
    let tempAuthor = [];
    let tempPublisher = [];
    let tempCate = [];
    let tempSubj = [];
    let tempCourse = [];
    let tempMedium = [];
    let tempVuser = [];
    let tempAvailUser = [];
    let tempSeries = [];
    let tempCateName = [];
    let tempCourseName = [];
    let tempSubjectName = [];
    let tempMediumName = [];
    let tempSeriesName = [];
    author_name.map((obj) => {
      tempAuthor.push(obj.id);
    });
    publisher_name.map((obj) => {
      tempPublisher.push(obj.id);
    });
    category_on.map((obj) => {
      tempCate.push(obj.id);
    });
    course_on.map((obj) => {
      tempCourse.push(obj.id);
    });
    subject_on.map((obj) => {
      tempSubj.push(obj.id);
    });
    medium_on.map((obj) => {
      tempMedium.push(obj.id);
    });
    visible_to_user.map((obj) => {
      tempVuser.push(obj.id);
    });
    availableToUser.map((obj) => {
      tempAvailUser.push(Number(obj.id));
    });
    series_on.map((obj) => {
      tempSeries.push(obj.id);
    });
    category_on?.map((obj) => {
      tempCateName.push(obj.name);
    });
    course_on?.map((obj) => {
      tempCourseName.push(obj.name);
    });
    subject_on?.map((obj) => {
      tempSubjectName.push(obj.name);
    });
    medium_on?.map((obj) => {
      tempMediumName.push(obj.name);
    });
    series_on?.map((obj) => {
      tempSeriesName.push(obj.name);
    });
    let statusFilter = {
      is_ebook: eBook.length === 0 ? "" : [parseInt(eBook[0].id)],
      is_free_book: freeBook,
      is_combo_offer:
        comboOffer.length === 0 ? "" : [parseInt(comboOffer[0].id)],
      // search: searchTerm.length > 0 ? searchTerm : "",
      search: searchTerm.length > 0 ? searchTerm : "",
      author_id: author_name.length > 0 ? tempAuthor : "",
      publisher_id: publisher_name.length > 0 ? tempPublisher : "",
      group_course_id:
        activeTab === 0 ? (course_on.length > 0 ? tempCourse : "") : "",
      subject_id:
        activeTab === 0 ? (subject_on.length > 0 ? tempSubj : "") : "",
      // individual
      category_id:
        activeTab === 0 ? (category_on.length > 0 ? tempCate : "") : "",
      medium: activeTab === 0 ? (medium_on.length > 0 ? tempMedium : "") : "",
      book_type:
        activeTab === 0
          ? series_on.length > 0
            ? tempSeries.map(Number)
            : ""
          : "",
      // bookset
      category_name:
        activeTab === 1 ? (category_on.length > 0 ? tempCateName : "") : "",
      group_course_name:
        activeTab === 1 ? (course_on.length > 0 ? tempCourseName : "") : "",
      subject_name:
        activeTab === 1 ? (subject_on.length > 0 ? tempSubjectName : "") : "",
      medium_name:
        activeTab === 1 ? (medium_on.length > 0 ? tempMediumName : "") : "",
      series_name:
        activeTab === 1 ? (series_on.length > 0 ? tempSeriesName : "") : "",
      is_set: activeTab,
      isvisible: activeTab === 1 && visible_to_user.length > 0 ? tempVuser : "",
      visible_user:
        activeTab === 0
          ? activeTab === 0 && visible_to_user.length > 0
            ? tempVuser
            : ""
          : availableToUser.length > 0
          ? tempAvailUser
          : "",
      select_set_list: 0,
      start_range_mrp: mrp.fromDate || "",
      end_range_mrp: mrp.toDate || "",
    };
    setIsLoading(true);
    AxiosInstance.post("/api/book/list", statusFilter)
      .then((res) => {
        if (res.data.status) {
          const FD = res.data.data;
          const serialNumberAddedData = FD.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));
          setOriginalListData(FD);
          setUpdateListData(serialNumberAddedData);
          getAPCSData(serialNumberAddedData);
          setCurrentPage(1);
          setIsLoading(false);
        } else {
          setUpdateListData([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        return error;
      });
  }

  // pagination start end -   item per page changing
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  // const currentData = csvListData.slice(start, end);

  const currentData = updateListData?.slice(start, end);

  const totalPages = Math.ceil(updateListData?.length / rowsPerPage);

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "phoneNumber") {
      if (value.length === 10 || value.length === 0) {
        setInitialfields((prevList) => ({
          ...prevList,
          [name]: value,
          userName: "", // Reset user name
          emailId: "", // Reset email
        }));
        setError((prevError) => ({
          ...prevError,
          phoneNumber: "",
        }));
        // Reset user-related states when phone number changes
        setUserCheck(false); // Enable "Check User" button
        setIsNewUser(false);
        setStatusCheck(false);
        setUserAddresses([]); // Clear previous user addresses
      } else {
        setCheckUserStatus(true);
        setSelectedUserBatch(null);
        setUserBatch([]);
        setSelectedUserBatch(null);
        setDelivery([]);
        // setUserCheckUserId(null);
        setInitialfields((prevList) => ({
          ...prevList,
          [name]: value,
        }));
        setError((prevError) => ({
          ...prevError,
          phoneNumber: "Please enter a valid 10-digit number",
        }));
        return;
      }
    }
    if (name === "newPhoneNumber") {
      if (value.length === 10 || value.length === 0) {
        setInitialfields((prevList) => ({
          ...prevList,
          [name]: value,
        }));
        setError((prevError) => ({
          ...prevError,
          newPhoneNumber: "",
        }));
      } else {
        setInitialfields((prevList) => ({
          ...prevList,
          [name]: value,
        }));
        setError((prevError) => ({
          ...prevError,
          newPhoneNumber: "Please enter a valid 10-digit number",
        }));
        return;
      }
    } else if (name === "emailId" || name === "userName") {
      let errorMessage = "";

      if (name === "emailId") {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!value.trim()) {
          errorMessage = "Email address is required";
        } else if (!emailRegex.test(value)) {
          errorMessage = "Please enter a valid email address";
        }

        setError((prev) => ({
          ...prev,
          emailId: errorMessage,
        }));
      }

      setInitialfields((prevFields) => ({
        ...prevFields,
        [name]: value,
        coupon_code: "",
        CouponAmount: 0,
        rewardPoints: "",
        rewardPointAmount: 0,
      }));

      setStatusCheck(false);
      setCouponApplied({
        status: false,
        amount: 0,
        coupon_code: "",
      });
      setMessage("");
      setListErrors({
        ...listErrors,
        ["coupon_code"]: "",
      });
      setRewardMessage("");

      setRewardAmount(0);
      setRewardsApplied({
        status: false,
        amount: 0,
        rewardPoints: "",
      });
    } else if (name === "deliveryMode") {
      setInitialfields((prevFields) => ({
        ...prevFields,
        deliveryMode: prevFields.deliveryMode === 1 ? 0 : 1,
      }));
    } else if (name === "payment_mode") {
      setInitialfields((prevList) => ({
        ...prevList,
        [name]: Number(value),
      }));
    } else if (name === "rewardPoints") {
      if (value !== "" && !/^\d+$/.test(value)) {
        return;
      }
      setRewardMessage("");
      setListErrors((prev) => ({
        ...prev,
        rewardPoints: ``,
      }));
      setError((prev) => ({
        ...prev,
        rewardPoints: "",
      }));
      if (value === "") {
        setRewardAmount(0);
        setInitialfields((prevFields) => ({
          ...prevFields,
          rewardPoints: "",
        }));
        setRewardsApplied({ status: false, amount: 0, rewardPoints: "" });
      } else {
        setInitialfields((prevFields) => ({
          ...prevFields,
          rewardPoints: value,
        }));
        setListErrors((prevErrors) => ({
          ...prevErrors,
          rewardPoints: "",
        }));
        setRewardAmount(0);
        setRewardsApplied({ status: false, amount: 0, rewardPoints: "" });
      }
    } else if (name === "pincode") {
      setInitialfields((prevFields) => ({
        ...prevFields,
        [name]: value,
      }));

      if (value.trim() === "") {
        setError((prevError) => ({
          ...prevError,
          pincode: "Please enter the pincode",
        }));
      } else if (value.length !== 6) {
        setError((prevError) => ({
          ...prevError,
          pincode: "Please enter a valid 6-digit pincode",
        }));
      } else {
        setError((prevError) => ({
          ...prevError,
          pincode: "",
        }));
      }
    } else if (name === "coupon_code") {
      setMessage("");
      setInitialfields((prevFields) => ({
        ...prevFields,
        [name]: value,
      }));
      setError((prevError) => ({
        ...prevError,
        [name]: "",
      }));
      setCouponApplied({
        status: false,
        amount: 0,
        coupon_code: "",
      });
    } else {
      setInitialfields((prevFields) => ({
        ...prevFields,
        [name]: value,
      }));

      setError((prevError) => ({
        ...prevError,
        [name]: "",
      }));
    }
  };

  const handleQuantityChange = (
    event,
    bookId,
    stockCount,
    weight,
    is_sert_available
  ) => {
    let inputValue = event.target.value;
    const updatedQuantity =
      inputValue === "" || isNaN(inputValue) ? 1 : parseInt(inputValue);

    setAllBookList((prevBooks) =>
      prevBooks.map((book) =>
        book.id === bookId ? { ...book, quantity: updatedQuantity } : book
      )
    );
    setPaginatedBooks((prevBooks) =>
      prevBooks.map((book) =>
        book.id === bookId ? { ...book, quantity: updatedQuantity } : book
      )
    );
    setError((prevError) => {
      const { [bookId]: currentError, ...rest } = prevError;
      if (currentError && currentError.quantity) {
        return {
          ...rest,
          [bookId]: { ...currentError, quantity: undefined },
        };
      }
      return rest;
    });

    // setInitialfields((prevFields) => ({
    //   ...prevFields,
    //   [bookId]: {
    //     ...prevFields[bookId],
    //     quantity: updatedQuantity,
    //   },
    // }));
    setItems((prevItems) =>
      prevItems.map((item) => {
        if (item.book_id === bookId) {
          const newYourPrice =
            updatedQuantity > 0
              ? item.finalPrice * updatedQuantity
              : item.finalPrice;
          return {
            ...item,
            quantity: updatedQuantity,
            your_price: newYourPrice,
          };
        }

        return item;
      })
    );
  };

  const [totalFinalPrice, setTotalFinalPrice] = useState(0);

  const basePrice = items.reduce((acc, cur) => {
    return (cur.price || 0) * (cur.quantity || 1) + acc;
  }, 0);

  const actualAmountPrice = items.reduce((acc, cur) => {
    return (cur.price || 0) * (cur.quantity || 1) + acc;
  }, 0);

  useEffect(() => {
    const base_Price = items.reduce((acc, cur) => {
      return (cur.price || 0) * (cur.quantity || 1) + acc;
    }, 0);
    const discount = items.reduce(
      (acc, cur) =>
        cur.freeBook === "yes"
          ? 0 + acc
          : (cur.finalPrice || 0) * (cur.quantity || 1) + acc,
      0
    );

    setTotalFinalPrice(base_Price - discount);
  }, [items]);

  // const CourierCharges =
  //   items.length > 0
  //     ? parseFloat(
  //       items
  //         .filter((item) => item.is_ebook !== 1)
  //         .reduce(
  //           (acc, cur) =>
  //             acc + (cur.weight ? cur.weight * (cur.quantity || 1) : 0),
  //           0
  //         )
  //         .toFixed(3)
  //     ) || 0
  //     : 0;
  useEffect(() => {
    const charges =
      items.length > 0
        ? parseFloat(
            items
              .filter((item) => item.is_ebook !== 1)
              .reduce(
                (acc, cur) =>
                  acc + (cur.weight ? cur.weight * (cur.quantity || 1) : 0),
                0
              )
              .toFixed(3)
          ) || 0
        : 0;

    setCourierCharges(charges);
  }, [items]);

  useEffect(() => {
    if (CourierCharges > 0 && freeBook === 0) {
      fetchCourierCharge(CourierCharges);
    } else {
      setCourierCharge(0);
    }
  }, [CourierCharges]);

  const fetchCourierCharge = async (weight) => {
    try {
      const response = await AxiosInstance.post("api/book/courier_charge", {
        kg: Number(weight), // Ensure weight is a number
      });

      if (response.data.status) {
        setCourierCharge(response.data.amount[0]); // Store the charge dynamically
        setError((prev) => ({ ...prev, CourierCharges: "" })); // Clear previous error if successful
      } else {
        setError((prev) => ({
          ...prev,
          CourierCharges: response.data.message,
        })); // Set validation error message
        setCourierCharge([]); // Prevent saving invalid charge
      }
    } catch (error) {
      setError((prev) => ({
        ...prev,
        CourierCharges: "Error fetching courier charge. Please try again.",
      }));
      console.error("Error fetching courier charge:", error);
      setCourierCharge([]);
    }
  };

  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  const handleNext = (val) => {
    setCurrentPage(val);
  };
  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
    setUpdateListData([]);
    loadListdata();
  };
  function loadChipdata() {
    let tempArr = [];
    if (mrp.fromDate || mrp.toDate) {
      tempArr.push({
        name: ` ${mrp.fromDate || 0} - ${mrp.toDate || 0}`,
        value: `MRP`,
        type: "price",
      });
    }
    filterSearch.map((obj) => {
      tempArr.push(obj);
    });
    filterAuthor.map((obj) => {
      tempArr.push(obj);
    });
    filterPublisher.map((obj) => {
      tempArr.push(obj);
    });
    filterCourse.map((obj) => {
      tempArr.push(obj);
    });
    filterSubject.map((obj) => {
      tempArr.push(obj);
    });
    filtervisible_to_user.map((obj) => {
      tempArr.push(obj);
    });
    filterAvalible_to_user.map((obj) => {
      tempArr.push(obj);
    });
    filterCategory.map((obj) => {
      tempArr.push(obj);
    });
    filterMedium.map((obj) => {
      tempArr.push(obj);
    });
    filterSeries.map((obj) => {
      tempArr.push(obj);
    });
    filterEBook.map((obj) => {
      tempArr.push(obj);
    });
    filterComboOffer.map((obj) => {
      tempArr.push(obj);
    });
    setUpdateChipData(tempArr);
  }
  const uniqueAuthors = Array.from(
    new Map(originalListData?.map((item) => [item.author_id, item])).values()
  );
  const uniquePublisher = Array.from(
    new Map(originalListData?.map((item) => [item.publisher_id, item])).values()
  );
  const handleFilterSearchFocus = (name) => {
    if (name == "course") {
      if (txtBSearch_course.current) {
        txtBSearch_course?.current?.focus();
        // Create a new KeyboardEvent
        const event = new KeyboardEvent("keydown", {
          key: "Enter",
          keyCode: 13,
          which: 13,
          code: "Enter",
          bubbles: true,
        });
        // Dispatch the event
        txtBSearch_course.current.dispatchEvent(event);
      }
    } else if (name == "subject") {
      if (txtBSearch_sub.current) {
        txtBSearch_sub?.current?.focus();
        // Create a new KeyboardEvent
        const event = new KeyboardEvent("keydown", {
          key: "Enter",
          keyCode: 13,
          which: 13,
          code: "Enter",
          bubbles: true,
        });
        // Dispatch the event
        txtBSearch_sub.current.dispatchEvent(event);
      }
    }
  };
  // Ref
  const addressFocusRef = useRef(null);
  const user_ref = useRef(null);
  const email_ref = useRef(null);
  const phone_ref = useRef(null);
  const delivery_ref = useRef(null);
  const actualPrice_ref = useRef(null);
  const specialOffer_ref = useRef(null);
  const couponCode_ref = useRef(null);
  const couponAmount_ref = useRef(null);
  const rewardPoints_ref = useRef(null);
  const rewardAmount_ref = useRef(null);
  const totalDiscount_ref = useRef(null);
  const coureieCharges_ref = useRef(null);
  const netAmount_ref = useRef(null);
  const ebook_ref = useRef(null);
  const filterRef_avaliable_to_user = useRef(null);
  const filterRef_author = useRef(null);
  const txtBSearch = useRef(null); //search icon
  const filterRef_publisher = useRef(null);
  const filterRef_medium = useRef(null);
  const filterRef_series = useRef(null);
  const filterRef_ebook = useRef(null);
  const filterRef_subject = useRef(null);
  const txtBSearch_sub = useRef(null);
  const filterRef_visible_to_user = useRef(null);
  const filterRef_combo_offer = useRef(null);
  const filterRef_category = useRef(null);
  const txtBSearch_course = useRef(null); //search icon
  const filterRef_course = useRef(null);
  const your_price_ref = useRef(null);
  const batch_ref = useRef(null);
  let filterSearch = [];
  let rowIndex = 1;
  // Validation error
  const validateFields = (data) => {
    const errors = {};
    if (!data.userName) {
      errors.userName = "Please enter a  user name";
    }
    // if (data.freeBook === "" || !data.freeBook) {
    //   errors.your_price = "Please enter a your price";
    // }

    if (!data.emailId) {
      errors.emailId = "Please enter a email";
    }
    if (!selectedUserBatch && freeBook === 1) {
      errors.batchId = "Please select a batch";
    }
    if (!data.phoneNumber) {
      errors.phoneNumber = "Please enter a phone number";
    }

    if (!allAreEbooks) {
      if (data.deliveryMode === null || data.deliveryMode === undefined) {
        errors.deliveryMode = "Please select a delivery mode";
      }
    }

    if (data.actualPrice === "") {
      errors.actualPrice = "Please enter a actual price";
    }
    if (data.specialOffer === "") {
      errors.specialOffer = "Please enter a special offer";
    }
    // if (data.coupon_code === "") {
    //   errors.coupon_code = "Please enter a coupon code";
    // }
    if (data.CouponAmount === "") {
      errors.CouponAmount = "Please enter a coupon code amount";
    }

    // if (data.rewardPoints === "") {
    //   errors.rewardPoints = "Please enter a reward points";
    // }
    if (data.rewardPointAmount === "") {
      errors.rewardPointAmount = "Please enter a reward points amount";
    }
    if (data.totalDiscount === "") {
      errors.totalDiscount = "Please enter a total discount";
    }
    if (data.CourierCharges === "" && initialfields.deliveryMode === 1) {
      errors.CourierCharges = "Please enter a courier charges";
    }
    if (data.netAmount === "") {
      errors.netAmount = "Please enter a net amount to pay";
    }
    validateFocusCommentSection(data);
    return errors;
  };
  const handleFilterCourseSearch = (event, names) => {
    if (names == "course") {
      const searchInput = event.target.value;
      if (searchInput !== "") {
        const matchingObjects = courseId.filter(
          (item) =>
            item.course_name &&
            item.course_name.toLowerCase().includes(searchInput.toLowerCase())
        );
        // Do something with the matchingObjects, such as updating state or displaying them in the UI
        setCourseIds(matchingObjects);
      } else {
        setCourseIds(courseId);
      }
    } else if (names == "subject") {
      const searchInput = event.target.value;
      if (searchInput !== "") {
        const matchingObjects = subjectId.filter(
          (item) =>
            item.subject_name &&
            item.subject_name.toLowerCase().includes(searchInput.toLowerCase())
        );
        // Do something with the matchingObjects, such as updating state or displaying them in the UI
        setSubjectIds(matchingObjects);
      } else {
        setSubjectIds(subjectId);
      }
    }
  };

  // focus the error fields in comment section
  const validateFocusCommentSection = (COMSECFO) => {
    if (!COMSECFO.userName) {
      user_ref.current?.focus();
    } else if (!COMSECFO.emailId) {
      email_ref.current?.focus();
    } else if (!COMSECFO.batchId) {
      batch_ref.current?.focus();
    } else if (!COMSECFO.phoneNumber) {
      phone_ref.current?.focus();
    } else if (!COMSECFO.deliveryMode) {
      delivery_ref.current?.focus();
    } else if (!COMSECFO.actualPrice) {
      actualPrice_ref.current?.focus();
    } else if (!COMSECFO.specialOffer) {
      specialOffer_ref.current?.focus();
    } else if (!COMSECFO.coupon_code) {
      couponCode_ref.current?.focus();
    } else if (!COMSECFO.CouponAmount) {
      couponAmount_ref.current?.focus();
    } else if (!COMSECFO.rewardPoints) {
      rewardPoints_ref.current?.focus();
    } else if (!COMSECFO.rewardPointAmount) {
      rewardAmount_ref.current?.focus();
    } else if (!COMSECFO.totalDiscount) {
      totalDiscount_ref.current?.focus();
    } else if (!COMSECFO.CourierCharges) {
      coureieCharges_ref.current?.focus();
    } else if (!COMSECFO.netAmount) {
      netAmount_ref.current?.focus();
    }
  };
  useEffect(() => {
    setIsLoading(true);
    AxiosInstance.post("api/all/coupon/findbyId", { id: parseInt(id) })
      .then((res) => {
        if (res.data.status === true) {
          setInitialfields({
            ...initialfields,
            Title: res.data.coupon_data[0].title,
            coupon_code: res.data.coupon_data[0].coupon_code,
            CouponAmount: res.data.coupon_data[0].amount || 0,
            TDate: moment(res.data.coupon_data[0].end_date).format(
              "YYYY-MM-DD"
            ),
            emailIds: res.data.applicable_users.map((item) => item.id),
            emailLabel: res.data.applicable_users.map((item) => item.email),
            userIds: res.data.applicable_users.map((item) => item.user_id),
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  }, [id]);

  const handleSort = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    let sortedList = updateListData.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      if (a[sortKey] == b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setUpdateListData(sortedList);
  };

  const handleChangeBookOrder = (e, bookId, bookList) => {
    const isChecked = e.target.checked;
    let totalPrices = 0;
    setAllBookList((prevAllBooks) => {
      const updatedBookList = isChecked
        ? [...prevAllBooks, bookList]
        : prevAllBooks.filter((book) => book.id !== bookId);

      return updatedBookList.map((book, index) => ({
        ...book,
        seriesNumber: index + 1,
      }));
    });
    setSelectedBooks((prev) => {
      let updatedBooks;
      if (isChecked) {
        updatedBooks = [...prev, bookId];
        setInitialfields((prevFields) => ({
          ...prevFields,
          [bookId]: {
            ...prevFields[bookId],
            freeBook: "no",
            quantity: 1,
          },
        }));
        setIsQuantityDisabled((prevState) => ({
          ...prevState,
          [bookId]: false,
        }));
        setCouponApplied({
          status: false,
          coupon_code: "",
          amount: "",
        });
        setRewardsApplied({
          status: false,
          rewardPoints: "",
        });
        setInitialfields((prev) => ({
          ...prev,
          rewardPoints: "",
          amount: "",
          coupon_code: "",
        }));

        setListErrors((prev) => ({
          ...prev,
          rewardPoints: "",
          coupon_code: "",
        }));
        setError((prev) => ({
          ...prev,
          coupon_code: "",
          rewardPoints: "",
        }));
      } else {
        updatedBooks = prev.filter((id) => id !== bookId);
        setRewardsApplied({
          status: false,
          rewardPoints: "",
        });
        setMessage("");
        setRewardMessage("");
        setCouponApplied({
          status: false,
          coupon_code: "",
          amount: "",
        });
        setInitialfields((prev) => ({
          ...prev,
          rewardPoints: "",
          amount: "",
          coupon_code: "",
        }));
        setListErrors((prev) => ({
          ...prev,
          rewardPoints: "",
          coupon_code: "",
        }));
        setError((prev) => ({
          ...prev,
          coupon_code: "",
          rewardPoints: "",
          CourierCharges: "",
        }));
      }
      const updatedItems = updatedBooks.map((id, index) => {
        let currentBook = items.find((item) => item.book_id === id);
        if (bookList.id === id) {
          currentBook = {
            ...currentBook,
            price: bookList.price,
            finalPrice: bookList.finalPrice,
            is_set: bookList.is_set,
            weight: bookList.weight,
            is_ebook: bookList.is_ebook,
            seriesNumber: index + 1,
          };
        }
        const bookPrice = currentBook ? currentBook.price : 0;
        const bookQuantity = currentBook?.quantity || 1;
        totalPrices += bookPrice * bookQuantity;
        return {
          book_id: id,
          quantity: bookQuantity,
          is_set: currentBook?.is_set,
          price: bookPrice,
          finalPrice: currentBook?.finalPrice,
          your_price: currentBook?.your_price,
          weight: currentBook?.weight,
          is_ebook:
            id === bookList.id ? bookList.is_ebook : currentBook?.is_ebook,
          seriesNumber: index + 1,
        };
      });

      setItems(updatedItems);

      return updatedBooks;
    });
  };

  const handleCheckboxChange = (event, typename) => {
    const { value, checked, name } = event.target;

    if (typename === "author") {
      if (checked) {
        setAuthor_name([
          ...author_name,
          { id: value, name: name, type: "author" },
        ]);
      } else {
        setAuthor_name(author_name.filter((item) => item.id !== value));
      }
    } else if (typename === "publisher") {
      if (checked) {
        setPublisher_name([
          ...publisher_name,
          { id: value, name: name, type: "publisher" },
        ]);
      } else {
        setPublisher_name(publisher_name.filter((item) => item.id !== value));
      }
    } else if (typename === "visible_to_user") {
      if (checked) {
        setVisible_to_user([
          // ...visible_to_user,
          { id: value, name: name, type: "visible_to_user" },
        ]);
      } else {
        setVisible_to_user(visible_to_user.filter((item) => item.id !== value));
      }
    } else if (typename === "availableToUser") {
      if (checked) {
        setavailableToUser([
          { id: value, name: name, type: "availableToUser" },
        ]);
      } else {
        setavailableToUser(availableToUser.filter((item) => item.id !== value));
      }
    } else if (typename === "category") {
      if (checked) {
        setCategory_on([
          ...category_on,
          { id: value, name: name, type: "category" },
        ]);
      } else {
        setCategory_on(category_on.filter((item) => item.id !== value));
      }
    } else if (typename === "course") {
      if (checked) {
        setCourse_on([...course_on, { id: value, name: name, type: "course" }]);
      } else {
        setCourse_on(course_on.filter((item) => item.id !== value));
      }
    } else if (typename === "subject") {
      if (checked) {
        setSubject_on([
          ...subject_on,
          { id: value, name: name, type: "subject" },
        ]);
      } else {
        setSubject_on(subject_on.filter((item) => item.id !== value));
      }
    } else if (typename === "medium") {
      if (checked) {
        setMedium_on([...medium_on, { id: value, name: name, type: "medium" }]);
      } else {
        setMedium_on(medium_on.filter((item) => item.id !== value));
      }
    } else if (typename === "address") {
      setSelectedAddress(value);
    } else if (typename === "seriesTag") {
      if (checked) {
        setSeries_on([
          ...series_on,
          { id: value, name: name, type: "seriesTag" },
        ]);
      } else {
        setSeries_on(series_on.filter((item) => item.id !== value));
      }
    } else if (typename === "eBook") {
      if (checked) {
        setEBook([{ id: value, name: name, type: "eBook" }]);
      } else {
        setEBook(eBook.filter((item) => item.id !== value));
      }
    } else if (typename === "comboOffer") {
      if (checked) {
        setComboOffer([{ id: value, name: name, type: "comboOffer" }]);
      } else {
        setComboOffer(comboOffer.filter((item) => item.id !== value));
      }
    }
  };
  const handleApplyFilter = (name, event) => {
    updateStateData();
    if (name === "author") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        author: false,
      });
    } else if (name === "publisher") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        publisher: false,
      });
    } else if (name === "visible_to_user") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        visible_to_user: false,
      });
    } else if (name === "category") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        category: false,
      });
    } else if (name === "availableToUser") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        availableToUser: false,
      });
    } else if (name === "course") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        course: false,
      });
    } else if (name === "subject") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        subject: false,
      });
    } else if (name === "medium") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        medium: false,
      });
    } else if (name === "seriesTag") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        seriesTag: false,
      });
    } else if (name === "eBook") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        is_ebook: false,
      });
    } else if (name === "comboOffer") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        is_combo_offer: false,
      });
    } else if (name === "price") {
      loadChipdata();

      setIsOpen({
        ...isOpen,
        price: false,
      });
    }
  };
  const handleFilter = (e, boxName) => {
    if (boxName === "author") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        author: !prevState.author, // Toggle the value
        visible_to_user: false,
        publisher: false,
        category: false,
        course: false,
        subject: false,
        medium: false,
        seriesTag: false,
        is_ebook: false,
        is_combo_offer: false,
      }));
      setAuthor_name(updateChipData.filter((ui) => ui.type === "author"));
    } else if (boxName === "publisher") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        visible_to_user: false,
        publisher: !prevState.publisher, // Toggle the value
        category: false,
        course: false,
        subject: false,
        medium: false,
        author: false,
        seriesTag: false,
        is_ebook: false,
        is_combo_offer: false,
      }));
      setPublisher_name(updateChipData.filter((ui) => ui.type === "publisher"));
    } else if (boxName === "visible_to_user") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        visible_to_user: !prevState.visible_to_user, // Toggle the value
        publisher: false,
        category: false,
        course: false,
        subject: false,
        medium: false,
        author: false,
        seriesTag: false,
        is_ebook: false,
        is_combo_offer: false,
      }));
      setVisible_to_user(
        updateChipData.filter((ui) => ui.type === "visible_to_user")
      );
    } else if (boxName === "availableToUser") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        availableToUser: !prevState.availableToUser, // Toggle the value
        category: false,
        course: false,
        subject: false,
        medium: false,
        seriesTag: false,
        is_ebook: false,
        is_combo_offer: false,
      }));
      setavailableToUser(
        updateChipData.filter((ui) => ui.type === "availableToUser")
      );
    } else if (boxName === "category") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        category: !prevState.category, // Toggle the value
        visible_to_user: false,
        publisher: false,
        course: false,
        subject: false,
        medium: false,
        author: false,
        seriesTag: false,
        is_ebook: false,
        is_combo_offer: false,
      }));
      setCategory_on(updateChipData.filter((ui) => ui.type === "category"));
    } else if (boxName === "course") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        course: !prevState.course, // Toggle the value
        category: false,
        visible_to_user: false,
        publisher: false,
        subject: false,
        medium: false,
        author: false,
        seriesTag: false,
        is_ebook: false,
        is_combo_offer: false,
      }));
      setCourse_on(updateChipData.filter((ui) => ui.type === "course"));
    } else if (boxName === "subject") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        subject: !prevState.subject, // Toggle the value
        course: false,
        category: false,
        visible_to_user: false,
        publisher: false,
        medium: false,
        author: false,
        seriesTag: false,
        is_ebook: false,
        is_combo_offer: false,
      }));
      setSubject_on(updateChipData.filter((ui) => ui.type === "subject"));
    } else if (boxName === "is_combo_offer") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        medium: false, // Toggle the value
        subject: false,
        course: false,
        category: false,
        visible_to_user: false,
        publisher: false,
        author: false,
        is_ebook: false,
        is_combo_offer: !prevState.is_combo_offer,
        seriesTag: false,
      }));
    } else if (boxName === "is_ebook") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        medium: false, // Toggle the value
        subject: false,
        course: false,
        category: false,
        visible_to_user: false,
        publisher: false,
        author: false,
        is_ebook: !prevState.is_ebook,
        seriesTag: false,
        is_combo_offer: false,
      }));
    } else if (boxName === "medium") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        medium: !prevState.medium, // Toggle the value
        subject: false,
        course: false,
        category: false,
        visible_to_user: false,
        publisher: false,
        author: false,
        seriesTag: false,
        is_ebook: false,
        is_combo_offer: false,
      }));
      setMedium_on(updateChipData.filter((ui) => ui.type === "medium"));
    } else if (boxName === "seriesTag") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        seriesTag: !prevState.seriesTag, // Toggle the value
        subject: false,
        course: false,
        category: false,
        visible_to_user: false,
        publisher: false,
        author: false,
        is_ebook: false,
        is_combo_offer: false,
      }));
      setSeries_on(updateChipData.filter((ui) => ui.type === "seriesTag"));
    } else if (boxName === "price") {
      setIsOpen((prevState) => ({
        ...prevState,
        seriesTag: false,
        subject: false,
        course: false,
        category: false,
        is_visible: false,
        publisher: false,
        author: false,
        is_combo_offer: false,
        is_free_book: false,
        price: !prevState.price,
        availableToUser: false,
        medium: false,
      }));
    }
  };

  const handleDelete = (chipToDelete, index) => () => {
    updateStateData();
    if (chipToDelete.type === "search") {
      setSearchTerm("");
      filterSearch = [];
    } else if (chipToDelete.type === "author") {
      setAuthor_name(author_name.filter((item) => item.id !== chipToDelete.id));
      filterAuthor = author_name.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "price") {
      setMrp({ fromDate: "", toDate: "" });
      setUpdateChipData([]);
    } else if (chipToDelete.type === "publisher") {
      setPublisher_name(
        publisher_name.filter((item) => item.id !== chipToDelete.id)
      );
      filterPublisher = publisher_name.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "visible_to_user") {
      setVisible_to_user(
        visible_to_user.filter((item) => item.id !== chipToDelete.id)
      );
      filtervisible_to_user = visible_to_user.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "availableToUser") {
      setavailableToUser(
        availableToUser.filter((item) => item.id !== chipToDelete.id)
      );
      filterAvalible_to_user = availableToUser.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "medium") {
      setMedium_on(medium_on.filter((item) => item.id !== chipToDelete.id));
      filterMedium = medium_on.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "subject") {
      setSubject_on(subject_on.filter((item) => item.id !== chipToDelete.id));
      filterSubject = subject_on.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "course") {
      setCourse_on(course_on.filter((item) => item.id !== chipToDelete.id));
      filterCourse = course_on.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "category") {
      setCategory_on(category_on.filter((item) => item.id !== chipToDelete.id));
      filterCategory = category_on.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "seriesTag") {
      setSeries_on(series_on.filter((item) => item.id !== chipToDelete.id));
      filterSeries = series_on.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "eBook") {
      setEBook(eBook.filter((item) => item.id !== chipToDelete.id));
      filterEBook = eBook.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "comboOffer") {
      setComboOffer(comboOffer.filter((item) => item.id !== chipToDelete.id));
      filterComboOffer = comboOffer.filter(
        (item) => item.id !== chipToDelete.id
      );
    }
    loadChipdata();
  };
  const handleAllClear = () => {
    setSearchTerm([]);
    setAuthor_name([]);
    setPublisher_name([]);
    setMedium_on([]);
    setSubject_on([]);
    setMrp({});
    setCourse_on([]);
    setCategory_on([]);
    setSeries_on([]);
    setVisible_to_user([]);
    setavailableToUser([]);
    setUpdateChipData([]);
    setEBook([]);
    setComboOffer([]);
  };

  const handleSubmit = () => {
    const err_bnh = validateFields(initialfields);
    let phoneNumber = initialfields.phoneNumber;
    let email = initialfields.emailId;
    if (phoneNumber) {
      if (phoneNumber.length === 10 && /^[0-9]+$/.test(phoneNumber)) {
        setError((prevError) => ({
          ...prevError,
          phoneNumber: "",
        }));
      } else {
        setError((prevError) => ({
          ...prevError,
          phoneNumber: "Please enter a valid 10-digit number",
        }));
        if (phone_ref.current) {
          phone_ref.current.focus();
        }
        return;
      }
    }
    if (
      initialfields.deliveryMode === 1 &&
      courierCharge?.amount != null &&
      freeBook !== 1 &&
      (!courierCharge || !courierCharge.amount == null || !courierCharge.id)
    ) {
      setError((prev) => ({
        ...prev,
        CourierCharges:
          "There is an issue with the courier charges. Please contact the AIASA administrator to complete your order.",
      }));
      return;
    }

    if (email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        setError((prevError) => ({
          ...prevError,
          emailId: "Please enter a valid email address",
        }));
        if (email_ref.current) {
          email_ref.current.focus();
        }
        return;
      } else {
        setError((prevError) => ({
          ...prevError,
          emailId: "",
        }));
      }
    }
    if (!allAreEbooks) {
      if (!selectedAddress) {
        toast.error("Please select a delivery address");
        if (addressFocusRef.current) {
          addressFocusRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
        return;
      }
    }

    if (Object.keys(err_bnh).length === 0) {
      try {
        let updateCoupon;

        updateCoupon = {
          username: initialfields.userName,
          email: initialfields.emailId,
          mobile: initialfields.phoneNumber,
          delivery_mode: allAreEbooks
            ? 0
            : parseInt(initialfields.deliveryMode),
          shipping_address_pk: allAreEbooks ? staffLocId || 2 : selectedAddress,
          location_id:
            user_type === 1 && initialfields.deliveryMode === 1
              ? 2
              : selectedAddress
              ? staffLocId || selectedAddress
              : user_type !== 1
              ? staffLocId || 2
              : 2,
          batch_id: selectedUserBatch ? selectedUserBatch?.batch_id : 0,
          payment_mode: initialfields.payment_mode,
          actual_price: basePrice,
          special_offer: totalFinalPrice,
          coupon_code:
            couponApplied.status === true
              ? initialfields.coupon_code || ""
              : "",
          coupon_amount: couponApplied.amount || 0,
          reward_used:
            parseInt(rewardsnApplied.status === true ? rewardAmount : 0) > 0
              ? 1
              : 0,
          reward_amount: parseInt(
            rewardsnApplied.status === true ? rewardAmount : 0
          ),
          total_discount:
            (totalFinalPrice || 0) +
            (couponApplied.amount || 0) +
            (rewardsnApplied.status ? Number(rewardAmount) : 0),

          // courier_charge: parseInt(initialfields.CourierCharges),
          // courier_charge: (initialfields.deliveryMode === 1 ? calculateCourierCharge(CourierCharges) : 0),
          courier_charge:
            initialfields.deliveryMode === 1
              ? freeBook === 1
                ? 0
                : courierCharge?.amount || 0
              : 0,
          courier_pk:
            initialfields.deliveryMode === 1
              ? freeBook === 1
                ? 0
                : courierCharge.id
              : 0,
          total_amount:
            basePrice -
            (Number(couponApplied.amount) +
              parseInt(rewardsnApplied.status === true ? rewardAmount : 0) +
              Number(totalFinalPrice)) +
            (freeBook === 1
              ? 0
              : (initialfields.deliveryMode == 1 && courierCharge?.amount) ||
                0),
          // (freeBook === 1 ? 0 : Number(actualAmountPrice)) +
          // // (initialfields.deliveryMode === 1 ? calculateCourierCharge(CourierCharges) : 0)) -
          // (initialfields.deliveryMode === 1
          //   ? freeBook === 1
          //     ? 0
          //     : courierCharge.amount
          //   : 0) -
          // (Number(totalFinalPrice) +
          //   Number(couponApplied.amount) +
          //   (rewardsnApplied.status ? Number(rewardAmount) : 0)),
          transaction_status: 4,
          transaction_order_id: "",
          cart_id: "",
          created_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
          created_by: userid,
          items: items || [],
        };
        setIsLoading(true);
        AxiosInstance.post(`api/book/new_purchase`, updateCoupon)
          .then((res) => {
            setIsLoading(false);
            if (res.data.status) {
              setDelivery([]);
              toast.success(res.data.message);
              navigate("/ListPurchase");

            } else {
              toast.error(res.data.message);
            }
          })
          .catch((error) => {
            setIsLoading(false);
            return error;
          });
      } catch (error) {
        setIsLoading(false);
        console.log(error);
      }
    } else {
      setError(err_bnh);
    }
  };

  const navigateToPreviousScreen = () => {
    navigate(-1); // Navigate back by one step in the history
  };

  const handleSearch = (event) => {
    if (event.key === "Enter") {
      let val = event.target.value;
      updateStateData();
      setSearchTerm(val);
      if (val.length > 0) {
        filterSearch = [{ name: "" + val, type: "search" }];
      } else {
        filterSearch = [];
      }
      loadChipdata();
    }
  };
  const handleSearchFocus = () => {
    if (txtBSearch.current) {
      txtBSearch.current.focus();

      // Create a new KeyboardEvent
      const event = new KeyboardEvent("keydown", {
        key: "Enter",
        keyCode: 13,
        which: 13,
        code: "Enter",
        bubbles: true,
      });

      // Dispatch the event
      txtBSearch.current.dispatchEvent(event);
    }
  };

  const handleClear = (name) => {
    const updatedChips = updateChipData.filter((item) => item.type !== name);
    setUpdateChipData(updatedChips);
    setIsOpen({
      author: false,
      publisher: false,
      visible_to_user: false,
      availableToUser: false,
      category: false,
      course: false,
      subject: false,
      medium: false,
      seriesTag: false,
      is_ebook: false,
      is_combo_offer: false,
    });
    if (name === "author") {
      setAuthor_name([]);
      filterAuthor = [];
    } else if (name === "price") {
      setMrp({});
      setIsOpen({
        ...isOpen,
        price: false,
      });
    } else if (name === "publisher") {
      setPublisher_name([]);
      filterPublisher = [];
    } else if (name === "visible_to_user") {
      setVisible_to_user([]);
      filtervisible_to_user = [];
    } else if (name === "availableToUser") {
      setavailableToUser([]);
      filterAvalible_to_user = [];
    } else if (name === "course") {
      setCourse_on([]);
      filterCourse = [];
    } else if (name === "category") {
      setCategory_on([]);
      filterCategory = [];
    } else if (name === "subject") {
      setSubject_on([]);
      filterSubject = [];
    } else if (name === "medium") {
      setMedium_on([]);
      filterMedium = [];
    } else if (name === "seriesTag") {
      setSeries_on([]);
      filterSubject = [];
    } else if (name === "eBook") {
      setEBook([]);
      filterEBook = [];
    } else if (name === "comboOffer") {
      setComboOffer([]);
      filterComboOffer = [];
    }
    updateStateData();
  };

  const bookType = [
    {
      lable: "Individual Books",
      id: 0,
    },
    {
      lable: "Booksets",
      id: 1,
    },
  ];
  useEffect(() => {
    if (freeStatus === false && freeBook === 1) {
      setError((prevError) => ({
        ...prevError,
        batchId:
          "No free book available as the user hasn’t enrolled in any batch yet.",
      }));
    }
  }, [freeStatus, freeBook]);
  const handleTabClick = (tabIndex, name) => {
    setActiveTab(tabIndex);
    setCurrentPage(1);
    setUpdateChipData([]);
    setSearchTerm([]);
    setAuthor_name([]);
    setPublisher_name([]);
    setavailableToUser([]);
    setCategory_on([]);
    setCourse_on([]);
    setSubject_on([]);
    setVisible_to_user([]);
    setMedium_on([]);
    setEBook([]);
    setSeries_on([]);
    setMrp({})
    setComboOffer([]);
  };

  const handleApplyCoupon = (e, dAmount, id) => {
    let code = initialfields.coupon_code;
    if (code === "") {
      setError((prev) => ({
        ...prev,
        coupon_code: "Please enter a valid coupon code",
      }));
      setMessage("");
    } else {
      setError((prev) => ({
        ...prev,
        coupon_code: "",
      }));
      AxiosInstance.post(`api/all/getCoupon`, {
        user_id: userCheckUserId,
        coupon_code: code,
      })
        .then((res) => {
          if (
            (res.data?.[0]?.status !== undefined && res.data[0].status) ||
            res.data?.status
          ) {
            setMessage(res.data.message);
            const couponData = res.data[0]?.data;
            const appliedRewardAmount =
              rewardsnApplied.status === true ? parseInt(rewardAmount) : 0;
            const totalDeductions =
              appliedRewardAmount + Number(totalFinalPrice);
            const remainingAmount = basePrice - totalDeductions;
            const couponDiscount = Number(couponData.dis_amt);
            if (remainingAmount < couponDiscount) {
              setCouponApplied({
                status: false,
                amount: 0,
                coupon_code: "",
              });
              setMessage(
                `The coupon amount exceeds the amount payable (${remainingAmount}) and cannot be applied`
              );
            } else {
              const netPayable = actualAmountPrice - Number(totalFinalPrice);

              if (
                Number(couponData.dis_amt) + Number(totalFinalPrice) >
                basePrice
              ) {
                setListErrors({
                  ...listErrors,
                  ["coupon_code"]: `The coupon amount exceeds the amount payable (${netPayable}) and cannot be applied`,
                });

                setCouponApplied((prevState) => ({
                  ...prevState,
                  coupon_code: "",
                }));
              } else if (couponData) {
                setListErrors({
                  ...listErrors,
                  ["coupon_code"]: "",
                });
                setCouponApplied({
                  status: true,
                  amount: res.data[0].data.dis_amt,
                  coupon_code: res.data[0].data.id,
                });
              }
            }
          } else {
            setCouponApplied({
              status: false,
              amount: 0,
              coupon_code: "",
            });
            setMessage(res.data.message);
          }
        })
        .catch((error) => {
          return error;
        });
    }
  };

  const handleGetBatchForUser = async (id) => {
    if (id) {
      try {
        const response = await AxiosInstance.post(`/api/book/batch/list`, {
          user_id: id,
        });
        if (response.status === 200 && response.data.status === true) {
          setUserBatch(response.data.data);
        } else {
          setFreeStatus(response.data.status);
          if (freeStatus === false && freeBook === 1) {
            setError((prevError) => ({
              ...prevError,
              batchId:
                "No free book available as the user hasn’t enrolled in any batch yet.",
            }));
          }

          console.error("Unexpected response", response);
        }
      } catch (error) {
        console.error("Error fetching batch data:", error);
      }
    } else {
      console.log("User Id Missing");
    }
  };

  const handleCheckUser = (number) => {
    let phoneNumber = initialfields?.phoneNumber
      ? initialfields.phoneNumber?.trim()
      : String(number).trim();

    if (!phoneNumber || !/^[0-9]{10}$/.test(phoneNumber)) {
      setError((prev) => ({
        ...prev,
        phoneNumber: "Please enter a valid 10-digit phone number",
      }));
      return;
    }
    setError({});
    // setError((prev) => ({ ...prev, phoneNumber: "" }));
    setStatusCheck(true);
    AxiosInstance.post(`/api/book/check_user`, { mobile_no: phoneNumber })
      .then((res) => {
        setStatusCheck(false);
        if (res.data.status && res.data.data.length > 0) {
          const userList = res.data.data;
          setCheckUserStatus(false);
          setUserCheck(true);
          setUserAddresses(userList);
          setIsNewUser(false);
          if (userList.length > 1) {
            if (reduxUserEmail && reduxUserEmail.length > 0) {
              const selectedUser = userList.find(
                (user) =>
                  user.email.toLowerCase() === reduxUserEmail.toLowerCase()
              );

              if (selectedUser) {
                setInitialfields({
                  ...initialfields,
                  phoneNumber: phoneNumber || number,
                  userName: selectedUser.fullname || "",
                  emailId: selectedUser.email || "",
                });
                handleAddresslist(selectedUser.user_id);
                setUserCheckUserId(selectedUser.user_id);
              } else {
                // If email not found in list
                setInitialfields({
                  ...initialfields,
                  phoneNumber: phoneNumber || number,
                  userName: "",
                  emailId: "",
                });
              }
            } else {
              // reduxUserEmail is empty
              setInitialfields({
                ...initialfields,
                phoneNumber: phoneNumber || number,
                userName: "",
                emailId: "",
              });
            }
          }
          if (userList.length === 1) {
            const selectedUser = userList[0];
            setUserCheckUserId(selectedUser.user_id);
            setInitialfields({
              ...initialfields,
              phoneNumber: phoneNumber ? phoneNumber : number,
              userName: selectedUser.fullname || "",
              emailId: selectedUser.email || "",
            });
            handleAddresslist(selectedUser.user_id);
            handleGetBatchForUser(selectedUser.user_id);
          }

          toast.success(res.data.message);
        } else {
          setUserCheck(false);
          setIsNewUser(true);
          setInitialfields({
            ...initialfields,
            userName: "",
            emailId: "",
            phoneNumber: phoneNumber ? phoneNumber : number,
          });
          toast.error(res.data.message);
        }
      })
      .catch((error) => {
        setStatusCheck(false);
        console.error("User check failed:", error);
      });
  };

  const handleRegisterUser = () => {
    const emailPattern = new RegExp("^[^@]+@[^@]+\\.[^@]+$");
    if (!initialfields.userName || !initialfields.emailId) {
      toast.error("Please fill in all required fields.");
      return;
    }
    if (!initialfields.emailId || !emailPattern.test(initialfields.emailId)) {
      // toast.error("");
      setError({
        ...error,
        emailId: "Please enter a valid email",
      });
      return;
    }

    setStatusCheck(true); //  Disable the button on click

    const payload = {
      first_name: initialfields.userName,
      last_name: "", // Static value as per API requirement
      email: initialfields.emailId,
      phone_no: initialfields.phoneNumber,
      password: "User@123", // Default password
      country_code: "+91",
      method: 0,
      registration_type: 1,
    };
    setIsLoading(true);
    AxiosInstance.post(`api/user/register`, payload)
      .then((res) => {
        setIsLoading(false);
        setStatusCheck(true); //  Ensure it's enabled after API call completes
        setError({
          ...error,
          emailId: "",
        });
        if (res.data.status) {
          toast.success("User registered successfully!");
          setCheckUserStatus(false);
          setUserCheck(true);
          setUserCheckUserId(res?.data?.data?.user_id); // Save user ID
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setStatusCheck(false);
        toast.error("User registration failed.");
        console.error("Registration Error:", error);
      });
  };

  const handleAddresslist = (userId) => {
    if (!userId) {
      console.warn("User ID is missing. Skipping API call.");
      return;
    }

    AxiosInstance.post("/api/book/cart/address/list", { user_id: userId })
      .then((res) => {
        if (
          res.data.status &&
          Array.isArray(res.data.data) &&
          res.data.data.length > 0
        ) {
          setDelivery(res.data.data);
        } else {
          setDelivery([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching addresses:", error);
        setDelivery([]);
      });
  };

  // **Handle Email Selection from Dropdown**
  const handleChangeSelectDropdown = (option, field) => {
    setUserBatch([]);
    setSelectedUserBatch(null);

    if (field === "emailId" && option) {
      const selectedUser = userAddresses.find(
        (user) => user.email === option.value
      );
      if (selectedUser) {
        setUserCheckUserId(selectedUser.user_id);
        handleGetBatchForUser(selectedUser.user_id);
        setError((e) => ({
          ...e,
          batchId: "",
        }));
        setInitialfields((prev) => ({
          ...prev,
          emailId: selectedUser.email,
          userName: selectedUser.fullname || "",
          coupon_code: "",
          CouponAmount: 0,
          rewardPoints: "",
          rewardPointAmount: 0,
        }));
        // Fetch address for selected user
        handleAddresslist(selectedUser.user_id);
        setSelectedAddress("");
        setStatusCheck(false);
        setCouponApplied({
          status: false,
          amount: 0,
          coupon_code: "",
        });
        setMessage("");
        setListErrors({
          ...listErrors,
          ["coupon_code"]: "",
        });
        setRewardMessage("");

        setRewardAmount(0);
        setRewardsApplied({
          status: false,
          amount: 0,
          rewardPoints: "",
        });
      }
      setError((prev) => ({
        ...prev,
        emailId: "",
        userName: "",
      }));
    }
  };

  const handleAddressClose = () => {
    const errors = validateERRORDEFields(
      initialfields.name,
      initialfields.newPhoneNumber,
      initialfields.address,
      initialfields.pincode
    );

    if (Object.keys(errors).length === 0) {
      if (!userCheckUserId) {
        toast.error("User ID is missing. Please register first.");
        return;
      }

      const addAddress = {
        id: isEditopen ? initialfields.EditID : "",
        user_id: userCheckUserId, //  Ensure user_id is passed
        name: initialfields.name,
        address: initialfields.address,
        phone_no: initialfields.newPhoneNumber,
        pincode: initialfields.pincode,
        created_dt: moment().format("YYYY-MM-DD"),
        created_by: userCheckUserId, //  Ensure created_by is also set
      };

      AxiosInstance.post("/api/book/cart/address/add", addAddress)
        .then((res) => {
          if (res.data.status) {
            toast.success(res.data.message);
            handleModelClose();
            handleAddresslist(userCheckUserId);
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((error) => {
          console.error("Address Addition Error:", error);
        });
    } else {
      setError(errors);
    }
  };

  const handleEditAddress = (datads) => {
    setOpen(true);
    setisEditopen(true);
    setInitialfields((prevList) => ({
      ...prevList,
      delivery_mode: 1,
      EditID: datads.id,
      name: datads.name,
      newPhoneNumber: datads.phone_no,
      address: datads.address,
      pincode: datads.pincode,
    }));
  };

  useEffect(() => {
    if (
      Number(initialfields.rewardPoints) +
        Number(totalFinalPrice) +
        Number(couponApplied.amount) >
      basePrice
    ) {
      setListErrors((prev) => ({
        ...prev,
        rewardPoints: `The reward points exceed the amount payable (${basePrice}) and cannot be applied`,
      }));
      // setListErrors({
      //   ...listErrors,
      //   ["rewardPoints"]:
      //     "The reward points exceeds the net amount and cannot be applied",
      // });
      setRewardsApplied((prevState) => ({
        ...prevState,
        status: false,
        rewardPoints: "",
      }));
    } else {
      setListErrors((prev) => ({
        ...prev,
        rewardPoints: "",
      }));
    }
  }, [rewardAmount, totalFinalPrice, basePrice]);

  const handleApplyReward = (dAmount) => {
    let code = initialfields.rewardPoints ?? "";
    if (code === "" || isNaN(code) || parseInt(code) <= 0) {
      setError((prev) => ({
        ...prev,
        rewardPoints: "Please enter a valid reward point amount",
      }));
      setRewardMessage("");
      return;
    } else {
      setError((prev) => ({
        ...prev,
        rewardPoints: "",
      }));
      const rewardData = {
        user_id: userCheckUserId,
        amount: parseInt(code),
      };
      AxiosInstance.post(`api/book/user_rewards`, rewardData)
        .then((res) => {
          if (res.data.status) {
            const netPayable =
              actualAmountPrice -
              (Number(totalFinalPrice) +
                Number(couponApplied.amount) +
                Number(rewardsnApplied.status === true ? rewardAmount : 0));
            // rewardsnApplied.status === true && listErrors.rewardPoints === ""
            if (
              Number(initialfields.rewardPoints) +
                Number(totalFinalPrice) +
                Number(couponApplied.amount) >
              basePrice
            ) {
              setListErrors({
                ...listErrors,
                ["rewardPoints"]: `The reward points exceed the amount payable (${netPayable}) and cannot be applied`,
              });

              setRewardsApplied((prevState) => ({
                ...prevState,
                // status: false,
                rewardPoints: "",
              }));
              setRewardMessage("");
            } else {
              setRewardAmount(initialfields.rewardPoints);
              setRewardsApplied((prevState) => ({
                ...prevState,
                status: true,
                amount: res.data?.data[0].reward_balance,
                rewardPoints: res.data?.data[0].id,
              }));
              setListErrors({
                ...listErrors,
                ["rewardPoints"]: "",
              });
            }
          } else {
            setRewardAmount(0);
            setRewardsApplied({
              status: false,
              amount: 0,
              rewardPoints: "",
            });
            setRewardMessage(res.data.message);
          }
        })
        .catch((error) => {
          return error;
        });
    }
  };
  const dispatch = useDispatch();
  const handleView = (id, is_set, book_ids) => {
  
    
    if (is_set === 0) {
      dispatch(
        setBookFilters({
          author: author_name,
          publisher: publisher_name,
          visibleToUser: visible_to_user,
          category: category_on,
          course: course_on,
          subject: subject_on,
          medium: medium_on,
          seriesTag: series_on,
          eBook: eBook,
          freeBook: freeBook,
          searchTerm: searchTerm,
          price: mrp,
          activeTab: activeTab,
        })
      );
      dispatch(
        setFilters({
          items: items,
          userEmail: initialfields.emailId,
          freeSales: freeBook,
          userNumber: initialfields.phoneNumber,
          fillCheckbox: selectedBooks,
          fillSelectBooks: allBookList,
          filterBooksItems: items,
        })
      );
      navigate(`/viewIndividualBook/${id}`, {
        state: {
          ITEM: items,
          USEREMAIL: initialfields.emailId,
          USERNUMBER: initialfields.phoneNumber,
          CHECKBOX: selectedBooks,
          SELECTEDBOKS: allBookList,
          AUTHOR: author_name,
          PUBLISHER: publisher_name,
          VISIBLETOUSER: visible_to_user,
          CATEGORY: category_on,
          COURSE: course_on,
          SUBJECT: subject_on,
          MEDIUM: medium_on,
          SERIESTAG: series_on,
          EBOOK: eBook,
          FREESALES: freeBook,
          PRICE: mrp,
          LABEL: "Back to Create New Sales",
          ACTIVETAB: activeTab,
          SEARCHTERM: searchTerm,
        },
      });
    } else {
      dispatch(
        setFilters({
          items: items,
          userEmail: initialfields.emailId,
          freeSales: freeBook,
          userNumber: initialfields.phoneNumber,
          fillCheckbox: selectedBooks,
          fillSelectBooks: allBookList,
          filterBooksItems: items,
        })
      );
      dispatch(
        setBookFilters({
          visibleToUser: visible_to_user,
          category: category_on,
          course: course_on,
          subject: subject_on,
          medium: medium_on,
          seriesTag: series_on,
          freeBook: freeBook,
          availableToUser: availableToUser,
          comboOffer: comboOffer,
          searchTerm: searchTerm,
          price: mrp,
          activeTab: activeTab,
        })
      );
      navigate(`/studyMaterials/Books/ViewBookSet/${book_ids}/${id}`, {
        state: {
          ITEM: items,
          USEREMAIL: initialfields.emailId,
          USERNUMBER: initialfields.phoneNumber,
          CHECKBOX: selectedBooks,
          SELECTEDBOKS: allBookList,
          AUTHOR: author_name,
          PUBLISHER: publisher_name,
          VISIBLETOUSER: visible_to_user,
          CATEGORY: category_on,
          COURSE: course_on,
          SUBJECT: subject_on,
          MEDIUM: medium_on,
          SERIESTAG: series_on,
          EBOOK: eBook,
          FREESALES: freeBook,
          PRICE: mrp,
          ACTIVETAB: activeTab,
          LABEL: "Back to Create New Sales",
          SEARCHTERM: searchTerm,
          IDS: id,
          BOOKIDS:book_ids
        },
      });
    }
  };

  const preOrderRows = useMemo(() => {
    if (
      !allBookList ||
      allBookList.length === 0 ||
      !allBookList.some((book) => book.pre_order?.length > 0)
    ) {
      return [];
    }
    return allBookList.reduce((acc, book) => {
      if (book.pre_order?.length > 0) {
        book.pre_order.forEach((item) => {
          acc.push({
            ...item,
            seriesNumber: acc.length + 1, //  Assigns sequential numbering
          });
        });
      }
      return acc;
    }, []);
  }, [allBookList]);

  const [rowsPerPageThree, setRowsPerPageThree] = useState(5);
  const [currentPageThree, setCurrentPageThree] = useState(1);
  const [selectedBookSort, setSelectedBookSort] = useState("asc");

  const [sortedRows, setSortedRows] = useState([]);

  useEffect(() => {
    setSortedRows([...preOrderRows]);
    setCurrentPageThree(1);
  }, [preOrderRows]);

  const totalPagesThree = Math.ceil(sortedRows.length / rowsPerPageThree);

  const paginatedRows = useMemo(() => {
    const startIndex = (currentPageThree - 1) * rowsPerPageThree;
    return sortedRows.slice(startIndex, startIndex + rowsPerPageThree);
  }, [sortedRows, currentPageThree, rowsPerPageThree]);
  const handlePageCountThree = (e) => {
    const newRowsPerPage = Number(e.target.value);
    setRowsPerPageThree(newRowsPerPage);
    setCurrentPageThree(1);
  };

  const handlePrevThree = () => {
    setCurrentPageThree((prev) => Math.max(prev - 1, 1));
  };

  const handleNextThree = () => {
    setCurrentPageThree((prev) => Math.min(prev + 1, totalPagesThree));
  };

  const SortSelectedBooks = (event, sortKey) => {
    event.preventDefault();

    const order = selectedBookSort === "asc" ? "desc" : "asc";
    setSelectedBookSort(order);

    const sortedList = [...sortedRows].sort((a, b) => {
      if (a[sortKey] < b[sortKey]) return order === "asc" ? -1 : 1;
      if (a[sortKey] > b[sortKey]) return order === "asc" ? 1 : -1;
      return 0;
    });

    setSortedRows(sortedList);
    setCurrentPageThree(1);
  };

  const handleScan = (event) => {
    setBarcode(event.target.value);
  };

  const fetchBookDetails = async (isbn_no) => {
    if (!isbn_no) return;
    try {
      const response = await AxiosInstance.post("/api/book/list", {
        search: "",
        isbn_no: isbn_no.length > 0 ? isbn_no : "",
        is_ebook: eBook.length === 0 ? "" : [parseInt(eBook[0].id)],
        is_free_book: freeBook,
        is_combo_offer:
          comboOffer.length === 0 ? "" : [parseInt(comboOffer[0].id)],
        book_type: "",
        author_id: "",
        publisher_id: "",
        category_id: "",
        group_course_id: "",
        subject_id: "",
        medium: "",
        is_set: "",
        visible_user: "",
        select_set_list: 0,
        page: "",
        page_size: "",
      });

      if (response.data.status && Array.isArray(response.data.data)) {
        if (response.data.data[0].is_visible === 0) {
          toast.error(
            `You cannot select the scanned book as it is visible user as "no"`
          );
          setBarcode("");
          return;
        }
        if (response.data.data[0].availableToUser === 0) {
          toast.error(
            `You cannot select the scanned book as it is available user as "no"`
          );
          setBarcode("");
          return;
        }

        if (
          paginatedBooks.some((book) => book.id === response.data.data[0].id)
        ) {
          toast.error("Book already selected");
          setBarcode("");
          return;
        }

        setAllBookList((prevBooks) => {
          const updatedBooks = [...prevBooks, ...response?.data?.data].map(
            (book, index) => ({
              ...book,
              seriesNumber: index + 1, //  Ensure continuous numbering
            })
          );
          return updatedBooks;
        });

        setPaginatedBooks((prevBooks) => {
          const updatedBooks = [...prevBooks, ...response?.data?.data].map(
            (book, index) => ({
              ...book,
              seriesNumber: index + 1, //  Ensure continuous numbering
            })
          );
          return updatedBooks;
        });

        setItems((prevBooks) => {
          const updatedItems = [
            ...prevBooks,
            ...response?.data?.data.map(
              ({ id, is_set, price, finalPrice, weight, is_ebook }, index) => ({
                book_id: id,
                quantity: 1,
                is_set,
                price,
                finalPrice,
                weight,
                is_ebook,
                seriesNumber: prevBooks.length + index + 1, //  Ensure correct series numbering
              })
            ),
          ];
          return updatedItems;
        });

        setSelectedBooks((prevBooks) => {
          return [...prevBooks, ...response.data.data.map((book) => book.id)];
        });
        setBarcode("");
        toast.success("Selected successfully");
      } else {
        toast.error(response.data.message);
        console.error("No book found for the given ISBN number");
        setBarcode("");
      }
    } catch (error) {
      console.error("Error fetching book details:", error);
    }
  };

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    fetchBookDetails(barcode);
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div
      className={`${createInfo.CourseInfoSec} BathHeader BathDet global_container`}
    >
      <div className="row">
        <div className="col-md-6 col-12">
          <h2 className="TitleHeader">
            {id ? "Edit Coupon" : "Create New Sales"}
          </h2>
        </div>
        <div className="col-md-6 col-12 ListBtn">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <Link
                to={id ? "javascript:void(0)" : "/ListPurchase"}
                onClick={id ? navigateToPreviousScreen : () => {}}
                className="secondaryButton "
                variant="secondary"
              >
                Back to Sales
              </Link>
            </li>
            <li class="ListBtnItems">
              {/* <Link
                to="javascript:void(0)"
                onClick={
                  userCheck && selectedBooks.length > 0
                    ? handleSubmit
                    : undefined
                }
                className={`primaryButton text-center ${
                  !userCheck || selectedBooks.length === 0 ? "disabledbtn" : ""
                }`}
                disabled={!userCheck || selectedBooks.length === 0}
                variant="primary"
              >
                Save Sales
              </Link> */}

              <Link
                to="javascript:void(0)"
                onClick={
                  userCheck && selectedBooks.length > 0
                    ? // ((initialfields.deliveryMode == 1 && courierCharge !== 0) ||
                      //   (initialfields.deliveryMode == 0 && courierCharge == 0))
                      handleSubmit
                    : undefined
                }
                className={`primaryButton text-center ${
                  !userCheck || selectedBooks.length === 0
                    ? // (initialfields.deliveryMode == 1 && courierCharge === 0)
                      "disabledbtn"
                    : ""
                }`}
                disabled={
                  !userCheck || selectedBooks.length === 0
                  // (initialfields.deliveryMode == 1 && courierCharge === 0)
                }
                variant="primary"
              >
                Save Sales
              </Link>
            </li>
          </ul>
        </div>
        {/* Sales Details */}
        <div className="row m-0 mb-4">
          <fieldset className="mt-3">
            <legend className="w-auto">Sales Details</legend>
            <form className="row g-3">
              {/* Phone Number Input */}
              <div className="col-md-6">
                <label
                  htmlFor="phoneNumber"
                  className="form-label confirm_value"
                >
                  Phone Number
                </label>
                <div className="d-flex">
                  <div className={createInfo.inputWidth}>
                    <input
                      ref={phone_ref}
                      className="desc_input_text w-100 rounded-2 input-font-size-sm"
                      type="number"
                      id="phoneNumber"
                      name="phoneNumber"
                      placeholder="Enter the phone number"
                      value={initialfields.phoneNumber || ""}
                      onChange={handleChange}
                    />
                    {error.phoneNumber && (
                      <small className="error_message">
                        {error.phoneNumber}
                      </small>
                    )}
                  </div>

                  <div className="" style={{ paddingLeft: "20px" }}>
                    <Link
                      to="javascript:void(0)"
                      onClick={
                        !userCheck && !isNewUser ? handleCheckUser : undefined
                      }
                      className={`primaryButton text-center ${
                        createInfo.applyaBtnWidth
                      } ${userCheck || isNewUser ? "disabledbtn" : ""}`}
                      disabled={userCheck || isNewUser}
                      variant="primary"
                    >
                      Check User
                    </Link>
                  </div>
                </div>
              </div>

              {/* Email Input (Creatable Select) */}
              <div className="col-md-6">
                <label htmlFor="emailId" className="form-label confirm_value">
                  {isNewUser ? "Enter Email" : "Email"}
                </label>

                {isNewUser ? (
                  // **New User → Allow Manual Entry**
                  <input
                    className="desc_input_text w-100 rounded-2 input-font-size-sm"
                    type="email"
                    id="emailId"
                    name="emailId"
                    placeholder="Enter your email"
                    value={initialfields.emailId || ""}
                    onChange={handleChange}
                  />
                ) : (
                  // **Existing User → Show Dropdown (No Manual Entry)**
                  <Select
                    className="shadow-none input-font-size"
                    name="emailId"
                    value={
                      initialfields.emailId
                        ? {
                            value: initialfields.emailId,
                            label: initialfields.emailId,
                          }
                        : null
                    }
                    onChange={(option) =>
                      handleChangeSelectDropdown(option, "emailId")
                    }
                    options={userAddresses?.map((user) => ({
                      value: user?.email,
                      label: user?.email,
                    }))}
                    placeholder="Email"
                    maxMenuHeight={200}
                    isDisabled={!userCheck} // Disable if no user is found
                  />
                )}

                {error.emailId && (
                  <small className="error_message">{error.emailId}</small>
                )}
              </div>
              {/* User Name Input */}
              <div className="col-md-6">
                <label htmlFor="userName" className="form-label confirm_value">
                  User Name
                </label>
                <input
                  ref={user_ref}
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  type="text"
                  id="userName"
                  name="userName"
                  placeholder="Enter the user name"
                  value={initialfields.userName || ""}
                  onChange={handleChange}
                  disabled={userCheck} // Disable input if user exists
                />
                {error.userName && (
                  <small className="error_message">{error.userName}</small>
                )}
              </div>
              {/* Register Now button - Show only for new users */}
              {isNewUser && (
                <div className="col-md-6 mt-5">
                  <Link
                    to="javascript:void(0)"
                    onClick={
                      !statusCheck &&
                      initialfields.userName &&
                      initialfields.emailId &&
                      !error.emailId
                        ? handleRegisterUser
                        : undefined
                    }
                    className={`primaryButton text-center ${
                      createInfo.applyaBtnWidth
                    } ${
                      statusCheck ||
                      !initialfields.userName ||
                      !initialfields.emailId ||
                      error.emailId
                        ? "disabledbtn"
                        : ""
                    }`}
                    disabled={
                      statusCheck ||
                      !initialfields.userName ||
                      !initialfields.emailId ||
                      error.emailId
                    }
                    variant="primary"
                  >
                    Register Now
                  </Link>
                </div>
              )}
              {/* Batch DropDown */}
              {freeBook === 1 && (
                <div className="col-md-6">
                  <label htmlFor="batchId" className="form-label confirm_value">
                    Batch
                  </label>
                  <Select
                    className="shadow-none input-font-size"
                    name="batchId"
                    ref={batch_ref}
                    value={
                      selectedUserBatch
                        ? {
                            value: selectedUserBatch?.batch_id,
                            label: selectedUserBatch?.batch_name,
                          }
                        : null
                    }
                    onChange={(option) => {
                      setSelectedUserBatch(option);
                      setError({});
                    }}
                    options={userBatch.map((batch) => ({
                      value: batch.batch_id,
                      label: batch.batch_name,
                      ...batch,
                    }))}
                    placeholder="Select Batch"
                    maxMenuHeight={200}
                    isDisabled={false}
                  />
                  {error.batchId && (
                    <small className="error_message">{error.batchId}</small>
                  )}
                </div>
              )}
            </form>
          </fieldset>
        </div>

        {/* delivery address */}
        {/* Delivery Address Section */}
        {!items.every((item) => item.is_ebook === 1) && (
          <div>
            <fieldset className="mt-3" ref={addressFocusRef}>
              <legend className="w-auto">
                {" "}
                {initialfields.deliveryMode == 1
                  ? "Delivery Address"
                  : "Pickup Address"}{" "}
              </legend>
              <form className="row g-3">
                {/* Delivery Mode Selection */}
                {/* Delivery Mode Selection */}
                <div className="col-md-6">
                  <label
                    htmlFor="examName"
                    className="form-label confirm_value cursorPnt"
                  >
                    {initialfields.deliveryMode == 1
                      ? "Delivery Mode"
                      : "Pickup Mode"}
                  </label>
                  <div>
                    <input
                      className={`shadow-none input-font-size ${createInfo.checkbox_radio} cursorPnt`}
                      type="radio"
                      checked={initialfields.deliveryMode == 1}
                      id="courier_delivery"
                      name="deliveryMode"
                      value={1}
                      onChange={(e) => {
                        handleChange(e);
                        setSelectedAddress("");
                      }}
                    />
                    <label
                      htmlFor="courier_delivery"
                      className={`${ListInfo.margin_right} form-label confirm_value cursorPnt me-3`}
                      style={{ verticalAlign: "unset", margin: "0" }}
                    >
                      Courier Delivery
                    </label>

                    {/* {freeBook === 0 && ( */}
                    <>
                      <input
                        className={`shadow-none input-font-size ${createInfo.checkbox_radio} cursorPnt me-3`}
                        type="radio"
                        id="branch_pickup"
                        name="deliveryMode"
                        value={0}
                        checked={initialfields.deliveryMode == 0}
                        onChange={(e) => {
                          handleChange(e);
                          setSelectedAddress("");
                        }}
                      />
                      <label
                        htmlFor="branch_pickup"
                        className="form-label confirm_value cursorPnt"
                        style={{ verticalAlign: "unset", margin: "0" }}
                      >
                        Branch Pickup
                      </label>
                    </>
                    {/* )} */}
                  </div>

                  {error.deliveryMode && (
                    <small className="error_message">
                      {error.deliveryMode}
                    </small>
                  )}
                </div>
                {initialfields.deliveryMode == 1 && (
                  <div className="col-md-6 col-12 ListBtn">
                    {/* {initialfields.deliveryMode == 1 && isRegistered && ( */}
                    <ul className="List-Button mt-2">
                      <li className="ListBtnItems">
                        <Link
                          to="javascript:void(0)"
                          className={`primaryButton text-center ${
                            checkUserStatus ? "disabledbtn" : ""
                          }`}
                          variant="primary"
                          onClick={
                            checkUserStatus
                              ? () => console.log("enter mobilenumber")
                              : handleModelOpen
                          }
                          disabled={checkUserStatus}
                        >
                          Add New Delivery Address
                        </Link>
                      </li>
                    </ul>
                    {/* )} */}
                  </div>
                )}
              </form>

              {/* Delivery Mode Addresses */}
              {initialfields.deliveryMode == 1 && (
                <div className="borderWidth mt-2">
                  {delivery.length > 0 ? (
                    delivery.map((io) => {
                      const courierRadioId = `selected_courier_delivery_${io.id}`;
                      return (
                        <div key={io.id} className="ulFilterListData d-flex">
                          <div className="filterListData col-md-6">
                            <input
                              type="radio"
                              className="ListCheckbox me-3"
                              name="onlineAddress"
                              value={io.id}
                              checked={selectedAddress == io.id}
                              id={courierRadioId}
                              onChange={(e) =>
                                handleCheckboxChange(e, "address")
                              }
                            />
                            <div className={StyleInfo.addressHead}>
                              <div>
                                <label
                                  htmlFor={courierRadioId}
                                  className="confirm_value"
                                >
                                  {io.name} - {io.phone_no}
                                </label>
                              </div>
                              <div>
                                <label
                                  htmlFor={courierRadioId}
                                  className="confirm_value"
                                >
                                  {io.address}
                                </label>
                              </div>
                              <div>
                                <label
                                  htmlFor={courierRadioId}
                                  className="confirm_value"
                                >
                                  {io.pincode}
                                </label>
                              </div>
                            </div>
                          </div>
                          <div
                            className={`${StyleInfo.editAddress} ListBtnItems col-md-6 d-flex justify-content-end`}
                          >
                            <a
                              href="#"
                              onClick={() => handleEditAddress(io)}
                              className="primaryButton"
                            >
                              <span className="material-icons me-1 fs-5 align-middle text-white">
                                border_color
                              </span>{" "}
                              Edit Address
                            </a>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <p className="text-center mb-0 mt-2">
                      No records to display
                    </p>
                  )}

                  {error.addre && (
                    <small className={StyleInfo.errors}>{error.addre}</small>
                  )}
                </div>
              )}

              {/* Branch Pickup Addresses */}
              {initialfields.deliveryMode == 0 && (
                <div className="borderWidth mt-2">
                  {branchdelivery.length > 0 ? (
                    <ul className="ulFilterListData">
                      {branchdelivery.map((ui) => {
                        const radioId = `selected_branch_pickup_${ui.id}`;
                        return (
                          <li key={ui.id} className="filterListData">
                            <input
                              type="radio"
                              className="ListCheckbox me-3"
                              name="NotYetAssigned"
                              value={ui.id}
                              checked={selectedAddress == ui.id}
                              id={radioId}
                              onChange={(e) =>
                                handleCheckboxChange(e, "address")
                              }
                            />
                            <div className={StyleInfo.addressHead}>
                              <div>
                                <label
                                  htmlFor={radioId}
                                  className="confirm_value"
                                >
                                  {ui.name} - {ui.phoneNumber}
                                </label>
                              </div>
                              <div>
                                <label
                                  htmlFor={radioId}
                                  className="confirm_value"
                                >
                                  {ui.address}
                                </label>
                              </div>
                              <div>
                                <label
                                  htmlFor={radioId}
                                  className="confirm_value"
                                >
                                  {ui.pincode}
                                </label>
                              </div>
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  ) : null}

                  {error.addre && (
                    <small className={StyleInfo.errors}>{error.addre}</small>
                  )}
                </div>
              )}
            </fieldset>
          </div>
        )}

        {open && (
          <Modal
            key={`modal-0-${0}`}
            show={open}
            onHide={handleModelClose}
            size="xl"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>
                <h5
                  className={`${ListInfo.view_title} fw-bold mb-0`}
                  id="exampleModalLabel"
                >
                  {isEditopen ? "Edit Address" : "Add New Delivery Address"}
                </h5>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <></>
              <div className="row global_container">
                <div className="col-12">
                  <form className="row g-3">
                    {/* Evaluator Name Dropdown */}
                    <div className="col-md-6">
                      <label for="name" class="form-label confirm_value ">
                        Name
                      </label>
                      <input
                        // ref={course_ref}
                        class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                        type="text"
                        id="Name"
                        name="name"
                        placeholder="Enter the name"
                        value={initialfields.name}
                        onChange={handleChange}
                      />
                      {error.name && (
                        <small className="error_message">{error.name}</small>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label
                        for="newPhoneNumber"
                        class="form-label confirm_value "
                      >
                        Phone Number
                      </label>
                      <input
                        // ref={course_ref}
                        class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                        type="text"
                        id="newPhoneNumber"
                        name="newPhoneNumber"
                        placeholder="Enter the phone number"
                        value={initialfields.newPhoneNumber}
                        onChange={handleChange}
                      />
                      {error.newPhoneNumber && (
                        <small className="error_message">
                          {error.newPhoneNumber}
                        </small>
                      )}
                    </div>

                    <div className="col-md-12">
                      <label for="address" class="form-label confirm_value ">
                        Address
                      </label>
                      <textarea
                        // ref={subject_ref}
                        className={`${ListInfo.desc_input} w-100 rounded p-2 input-font-size`}
                        placeholder="Enter the address"
                        id="address"
                        onChange={(e) => handleChange(e)}
                        value={initialfields.address}
                        name="address"
                        maxLength={500}
                        style={{
                          height: "auto",
                          // minHeight: "calc(24px * 8)",
                        }}
                      ></textarea>
                      {error.address && (
                        <small className="error_message">{error.address}</small>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label for="pincode" class="form-label confirm_value ">
                        Pincode
                      </label>
                      <input
                        // ref={course_ref}
                        class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                        type="text"
                        id="pincode"
                        name="pincode"
                        placeholder="Enter the pincode"
                        value={initialfields.pincode}
                        onChange={handleChange}
                      />
                      {error.pincode && (
                        <small className="error_message">{error.pincode}</small>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <ul className="List-Button">
                <li className="ListBtnItems">
                  <Link onClick={handleModelClose} className="secondaryButton">
                    Back to Create New Sales
                  </Link>
                </li>
                <li className="ListBtnItems">
                  <Link onClick={handleAddressClose} className="primaryButton">
                    {isEditopen ? "Update Now" : "Add Now"}
                  </Link>
                </li>
              </ul>
            </Modal.Footer>
          </Modal>
        )}
        <div className="row m-0 mb-4">
          <fieldset className="mt-3">
            <legend className="w-auto mb-0">Select Books</legend>

            <div>
              <label htmlFor="freeBook" className="form-label confirm_value">
                Is this a free sale?
              </label>

              <div>
                <input
                  ref={freeBook_ref}
                  className={`shadow-none input-font-size ${createInfo.checkbox_radio}`}
                  type="radio"
                  id="freeSale_yes"
                  name="freeBook"
                  value={1}
                  checked={freeBook === 1}
                  onChange={handleFreeBookChange}
                />
                <label
                  htmlFor="freeSale_yes"
                  className={`${createInfo.margin_right} form-label confirm_value me-3`}
                  style={{ verticalAlign: "unset", margin: "0" }}
                >
                  Yes
                </label>

                <input
                  ref={freeBook_ref}
                  className={`shadow-none input-font-size ${createInfo.checkbox_radio}`}
                  type="radio"
                  id="freeSale_no"
                  name="freeBook"
                  value={0}
                  checked={freeBook === 0}
                  onChange={handleFreeBookChange}
                />
                <label
                  htmlFor="freeSale_no"
                  className="form-label confirm_value"
                  style={{ verticalAlign: "unset", margin: "0" }}
                >
                  No
                </label>
              </div>
            </div>

            <div
              className={`${
                bookType?.length === 0 ? "d-none" : "course-content-nav"
              } mb-2 mt-2 d-flex`}
            >
              {bookType?.length > 0 ? (
                bookType.map((item, itemIndex) => (
                  <div key={itemIndex}>
                    <ul
                      className="nav"
                      id={`tabList-${itemIndex}`}
                      role="tablist"
                    >
                      <li className="nav-item" role="presentation">
                        <button
                          className={
                            activeTab === itemIndex
                              ? "nav-link active"
                              : "nav-link"
                          }
                          id={`tab-${itemIndex}`}
                          data-bs-toggle="tab"
                          data-bs-target={`#tab-pane-${itemIndex}`}
                          type="button"
                          role="tab"
                          aria-controls={`tab-pane-${itemIndex}`}
                          aria-selected={activeTab === itemIndex}
                          onClick={() => handleTabClick(item.id)}
                        >
                          {item.lable}
                        </button>
                      </li>
                    </ul>
                  </div>
                ))
              ) : (
                <></>
              )}
            </div>
            <div className="row ">
              <div className="col-md-3 col-12 mt-3 ">
                <div class={StyleInfo.searchInputSec}>
                  <input
                    className={`${StyleInfo.searchInput} w-100`}
                    type="text"
                    placeholder={
                      activeTab == 0
                        ? "Search by Book Name"
                        : "Search by Bookset Name"
                    }
                    name="search_book_title"
                    onKeyDown={handleSearch}
                    ref={txtBSearch}
                  />

                  <Search
                    onClick={handleSearchFocus}
                    className={`${StyleInfo.ListsearchIcon}`}
                  />
                </div>
              </div>
            </div>
            {updateChipData?.length > 0 && bookType?.length > 0 ? (
              <div className="row mt-3">
                <div className="col-md-12 col-sm-12 col-xs-12 paperil_global">
                  <Paper
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexWrap: "wrap",
                      listStyle: "none",
                      p: 0.5,
                      m: 0,
                    }}
                    component="ul"
                  >
                    {updateChipData.map((data, index) => {
                      let icon;
                      return (
                        <ListItem key={index}>
                          <Chip
                            icon={icon}
                            label={
                              <>
                                <span className={StyleInfo.BoldTyText}>
                                  {data.type === "price"
                                    ? `Price: ${data.name}`
                                    : data.name}
                                </span>
                              </>
                            }
                            onDelete={handleDelete(data, index)}
                          />
                        </ListItem>
                      );
                    })}
                    <ListItem className="clearAll_list">
                      <a
                        className="clearAll_listItem"
                        href="javascript:void(0)"
                        onClick={handleAllClear}
                      >
                        Clear All Filters
                      </a>
                    </ListItem>
                  </Paper>
                </div>
              </div>
            ) : (
              <div></div>
            )}
            <div className="row mx-0 mt-4">
              <div className="col-md-12 table-responsive tableMinHeight px-0 ">
                <table className="table" id="tableListHeader">
                  <thead>
                    <tr>
                      <th id="th" className={StyleInfo.tableThPadding}></th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span
                          onClick={(e) => handleSort(e, "serialNumber")}
                          className="textHead_th"
                        >
                          S.No.
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "serialNumber")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span
                          onClick={(e) => handleSort(e, "book_title")}
                          className="textHead_th"
                        >
                          {activeTab === 0 ? "Book Name " : "Bookset Name"}
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "book_title")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      {activeTab === 0 && (
                        <>
                          <th
                            id="th"
                            className={StyleInfo.tableThPadding}
                            ref={filterRef_author}
                          >
                            <span
                              onClick={(e) => handleSort(e, "author")}
                              className="textHead_th"
                            >
                              Author
                            </span>
                            <span
                              onClick={(e) => handleSort(e, "author")}
                              className={`textHead_th material-icons align-middle`}
                            >
                              import_export{" "}
                            </span>
                            <span
                              className={`textHead_th align-middle material-icons ${
                                author_name.length > 0
                                  ? StyleInfo.active_icons_book
                                  : ""
                              } ${
                                isOpen.author ? StyleInfo.active_icons_book : ""
                              }`} // Change here
                              onClick={(e) => handleFilter(e, "author")}
                            >
                              filter_list
                            </span>
                            {isOpen.author && (
                              <>
                                <div className="filterBoxs_testlist mt-3">
                                  <div className="col-md-12 form-check filterStatus_list">
                                    <ul className={` ulFilterListData `}>
                                      {uniqueAuthors?.map((el) => (
                                        <li
                                          className={`filterListData ${
                                            el.author_id === 0 ? "d-none" : ""
                                          }`}
                                        >
                                          <input
                                            className="ListCheckbox"
                                            type="checkbox"
                                            name={el.author}
                                            value={el.author_id}
                                            id={el.author}
                                            checked={author_name.some(
                                              (element) => {
                                                if (
                                                  element.id == el.author_id
                                                ) {
                                                  return true;
                                                }
                                                return false;
                                              }
                                            )}
                                            onChange={(e) =>
                                              handleCheckboxChange(e, "author")
                                            }
                                          />
                                          <label
                                            className="form-check-label filterChipText_withoutBG "
                                            htmlFor={el.author}
                                          >
                                            {el.author}
                                          </label>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                  <div className="borderWidth row">
                                    <ul className="List-Button">
                                      <li className="ListBtnItems">
                                        <Link
                                          to={"javascript:void(0)"}
                                          onClick={() => handleClear("author")}
                                          className="secondaryButton "
                                        >
                                          Clear
                                        </Link>
                                      </li>
                                      <li className="ListBtnItems">
                                        <Link
                                          disabled={
                                            author_name.length === 0
                                              ? true
                                              : false
                                          }
                                          onClick={() =>
                                            handleApplyFilter("author")
                                          }
                                          className="primaryButton"
                                        >
                                          Apply Filter
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </>
                            )}
                          </th>
                          <th
                            id="th"
                            className={StyleInfo.tableThPadding}
                            ref={filterRef_publisher}
                          >
                            <span
                              onClick={(e) => handleSort(e, "publisher")}
                              className="textHead_th"
                            >
                              Publisher
                            </span>
                            <span
                              onClick={(e) => handleSort(e, "publisher")}
                              className={`textHead_th material-icons align-middle`}
                            >
                              import_export{" "}
                            </span>
                            <span
                              className={`textHead_th align-middle material-icons ${
                                publisher_name.length > 0
                                  ? StyleInfo.active_icons_book
                                  : ""
                              } ${
                                isOpen.publisher
                                  ? StyleInfo.active_icons_book
                                  : ""
                              }`} // Change here
                              onClick={(e) => handleFilter(e, "publisher")}
                            >
                              filter_list
                            </span>
                            {isOpen.publisher && (
                              <>
                                <div className="filterBoxs_testlist mt-3">
                                  <div className="col-md-12 form-check filterStatus_list">
                                    {uniquePublisher.map((el) => (
                                      <li
                                        className={`filterListData ${
                                          el.publisher_id === 0 ? "d-none" : ""
                                        }`}
                                      >
                                        <input
                                          className="ListCheckbox"
                                          type="checkbox"
                                          name={el.publisher}
                                          value={el.publisher_id}
                                          id={el.publisher}
                                          checked={publisher_name.some(
                                            (element) => {
                                              if (
                                                element.id == el.publisher_id
                                              ) {
                                                return true;
                                              }
                                              return false;
                                            }
                                          )}
                                          onChange={(e) =>
                                            handleCheckboxChange(e, "publisher")
                                          }
                                        />
                                        <label
                                          className="form-check-label filterChipText_withoutBG "
                                          htmlFor={el.publisher}
                                        >
                                          {el.publisher}
                                        </label>
                                      </li>
                                    ))}
                                  </div>
                                  <div className="borderWidth row">
                                    <ul className="List-Button">
                                      <li className="ListBtnItems">
                                        <Link
                                          to={"javascript:void(0)"}
                                          onClick={() =>
                                            handleClear("publisher")
                                          }
                                          className="secondaryButton "
                                        >
                                          Clear
                                        </Link>
                                      </li>
                                      <li className="ListBtnItems">
                                        <Link
                                          disabled={
                                            publisher_name.length === 0
                                              ? true
                                              : false
                                          }
                                          onClick={() =>
                                            handleApplyFilter("publisher")
                                          }
                                          className="primaryButton"
                                        >
                                          Apply Filter
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </>
                            )}
                          </th>
                        </>
                      )}
                      {activeTab === 1 && (
                        <th id="th" className={ListInfo.tableThPadding}>
                          <div class={ListInfo.thcontent}>
                            <span
                              onClick={(e) => handleSort(e, "totalBooksCount")}
                              class="textHead_th"
                            >
                              No. Of <br /> Books
                            </span>
                            <div class={ListInfo.iconcontainer}>
                              <span
                                onClick={(e) =>
                                  handleSort(e, "totalBooksCount")
                                }
                                className={`textHead_th material-icons align-middle`}
                              >
                                import_export{" "}
                              </span>
                            </div>
                          </div>
                        </th>
                      )}
                      <th
                        id="th"
                        className={StyleInfo.tableThPadding}
                        ref={filterRef_visible_to_user}
                      >
                        <div class={ListInfo.thcontent}>
                          <span
                            onClick={(e) => handleSort(e, "is_visible")}
                            className="textHead_th"
                          >
                            Visible <br /> to Users
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "is_visible")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                          <span
                            className={`textHead_th align-middle material-icons ${
                              visible_to_user.length > 0
                                ? StyleInfo.active_icons_book
                                : ""
                            } ${
                              isOpen.visible_to_user
                                ? StyleInfo.active_icons_book
                                : ""
                            }`} // Change here
                            onClick={(e) => handleFilter(e, "visible_to_user")}
                          >
                            filter_list
                          </span>
                        </div>

                        {isOpen.visible_to_user && (
                          <>
                            <div className="filterBoxs_testlist mt-5">
                              <div className="col-md-12 form-check filterStatus_list">
                                <ul className="ulFilterListData">
                                  <li className="filterListData">
                                    <input
                                      className="ListCheckbox"
                                      type="checkbox"
                                      name={"Visible to Users : Yes"}
                                      value={1}
                                      checked={visible_to_user.some(
                                        (element) => {
                                          if (element.id == "1") {
                                            return true;
                                          }
                                          return false;
                                        }
                                      )}
                                      id={"visible_to_user_Yes"}
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          e,
                                          "visible_to_user"
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label filterChipText_withoutBG "
                                      htmlFor={"visible_to_user_Yes"}
                                    >
                                      Yes
                                    </label>
                                  </li>
                                  <li className="filterListData">
                                    <input
                                      className="ListCheckbox"
                                      type="checkbox"
                                      name={"Visible to Users : No"}
                                      value={0}
                                      checked={visible_to_user.some(
                                        (element) => {
                                          if (element.id == "0") {
                                            return true;
                                          }
                                          return false;
                                        }
                                      )}
                                      id={"visible_to_user_No"}
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          e,
                                          "visible_to_user"
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label filterChipText_withoutBG "
                                      htmlFor={"visible_to_user_No"}
                                    >
                                      No
                                    </label>
                                  </li>
                                </ul>
                              </div>
                              <div className="borderWidth row">
                                <ul className="List-Button">
                                  <li className="ListBtnItems">
                                    <Link
                                      to={"javascript:void(0)"}
                                      onClick={() =>
                                        handleClear("visible_to_user")
                                      }
                                      className="secondaryButton "
                                    >
                                      Clear
                                    </Link>
                                  </li>
                                  <li className="ListBtnItems">
                                    <Link
                                      disabled={
                                        visible_to_user.length === 0
                                          ? true
                                          : false
                                      }
                                      onClick={() =>
                                        handleApplyFilter("visible_to_user")
                                      }
                                      className="primaryButton"
                                    >
                                      Apply Filter
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </>
                        )}
                      </th>
                      <th
                        id="th"
                        className={StyleInfo.tableThPadding}
                        ref={filterRef_category}
                      >
                        <span
                          onClick={(e) => handleSort(e, "category_name")}
                          className="textHead_th"
                        >
                          Category
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "category_name")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>

                        <span
                          className={`textHead_th align-middle material-icons ${
                            category_on.length > 0
                              ? StyleInfo.active_icons_book
                              : ""
                          } ${
                            isOpen.category ? StyleInfo.active_icons_book : ""
                          }`} // Change here
                          onClick={(e) => handleFilter(e, "category")}
                        >
                          filter_list
                        </span>

                        {isOpen.category && (
                          <>
                            <div className="filterBoxs_testlist mt-3">
                              <div className="col-md-12 form-check filterStatus_list">
                                <ul className="ulFilterListData">
                                  {categoryId.map((el) => (
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={el.name}
                                        value={el.id}
                                        id={el.name}
                                        checked={category_on.some((element) => {
                                          if (element.name == el.name) {
                                            return true;
                                          }
                                          return false;
                                        })}
                                        onChange={(e) =>
                                          handleCheckboxChange(e, "category")
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={el.name}
                                      >
                                        {el.name}
                                      </label>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                              <div className="borderWidth row">
                                <ul className="List-Button">
                                  <Link
                                    to={"javascript:void(0)"}
                                    onClick={() => handleClear("category")}
                                    className="secondaryButton "
                                  >
                                    Clear
                                  </Link>
                                  <li className="ListBtnItems">
                                    <Link
                                      disabled={
                                        category_on.length === 0 ? true : false
                                      }
                                      onClick={() =>
                                        handleApplyFilter("category")
                                      }
                                      className="primaryButton"
                                    >
                                      Apply Filter
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </>
                        )}
                      </th>
                      {activeTab === 0 && (
                        <th
                          id="th"
                          className={StyleInfo.tableThPadding}
                          ref={filterRef_course}
                        >
                          <span
                            onClick={(e) => handleSort(e, "group_course_name")}
                            className="textHead_th"
                          >
                            Course
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "group_course_name")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                          <span
                            className={`textHead_th align-middle material-icons ${
                              course_on.length > 0
                                ? StyleInfo.active_icons_book
                                : ""
                            } ${
                              isOpen.course ? StyleInfo.active_icons_book : ""
                            }`} // Change here
                            onClick={(e) => handleFilter(e, "course")}
                          >
                            filter_list
                          </span>
                          {isOpen.course && (
                            <>
                              <div className="filterBoxs_testlist mt-3">
                                <div className="col-md-12 form-check filterStatus_list">
                                  <ul className="ulFilterListData">
                                    <li
                                      className={`filterListData ${ListInfo.searchInputSec}`}
                                    >
                                      <input
                                        className={`${ListInfo.searchInput} w-100`}
                                        type="text"
                                        placeholder="Search by course"
                                        name="search_book_title"
                                        onKeyDown={(e) =>
                                          handleFilterCourseSearch(e, "course")
                                        }
                                        ref={txtBSearch_course}
                                      />
                                      <Search
                                        onClick={(e) =>
                                          handleFilterSearchFocus("course")
                                        }
                                        className={`${ListInfo.ListsearchIcon}`}
                                      />
                                    </li>

                                    {courseIds.map((el) => (
                                      <li className="filterListData">
                                        <input
                                          className="ListCheckbox"
                                          type="checkbox"
                                          name={el.course_name}
                                          value={el.course_id}
                                          id={el.course_name}
                                          checked={course_on.some((element) => {
                                            if (element.id == el.course_id) {
                                              return true;
                                            }
                                            return false;
                                          })}
                                          onChange={(e) =>
                                            handleCheckboxChange(e, "course")
                                          }
                                        />
                                        <label
                                          className="form-check-label filterChipText_withoutBG "
                                          htmlFor={el.course_name}
                                        >
                                          {el.course_name}
                                        </label>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                                <div className="borderWidth row">
                                  <ul className="List-Button">
                                    <li className="ListBtnItems">
                                      <Link
                                        to={"javascript:void(0)"}
                                        onClick={() => handleClear("course")}
                                        className="secondaryButton "
                                      >
                                        Clear
                                      </Link>
                                    </li>
                                    <li className="ListBtnItems">
                                      <Link
                                        disabled={
                                          course_on.length === 0 ? true : false
                                        }
                                        onClick={() =>
                                          handleApplyFilter("course")
                                        }
                                        className="primaryButton"
                                      >
                                        Apply Filter
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </>
                          )}
                        </th>
                      )}
                      {activeTab === 1 && (
                        <th
                          id="th"
                          className={StyleInfo.tableThPadding}
                          ref={filterRef_course}
                        >
                          <span
                            onClick={(e) => handleSort(e, "group_course_name")}
                            className="textHead_th"
                          >
                            Course
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "group_course_name")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                          <span
                            className={`textHead_th align-middle material-icons ${
                              course_on.length > 0
                                ? StyleInfo.active_icons_book
                                : ""
                            } ${
                              isOpen.course ? StyleInfo.active_icons_book : ""
                            }`} // Change here
                            onClick={(e) => handleFilter(e, "course")}
                          >
                            filter_list
                          </span>
                          {isOpen.course && (
                            <>
                              <div className="filterBoxs_testlist mt-3">
                                <div className="col-md-12 form-check filterStatus_list">
                                  <ul className="ulFilterListData">
                                    <li
                                      className={`filterListData ${ListInfo.searchInputSec}`}
                                    >
                                      <input
                                        className={`${ListInfo.searchInput} w-100`}
                                        type="text"
                                        placeholder="Search by course"
                                        name="search_book_title"
                                        onKeyDown={(e) =>
                                          handleFilterCourseSearch(e, "course")
                                        }
                                        ref={txtBSearch_course}
                                      />
                                      <Search
                                        onClick={(e) =>
                                          handleFilterSearchFocus("course")
                                        }
                                        className={`${ListInfo.ListsearchIcon}`}
                                      />
                                    </li>

                                    {courseIds.map((el) => (
                                      <li className="filterListData">
                                        <input
                                          className="ListCheckbox"
                                          type="checkbox"
                                          name={el.course_name}
                                          value={el.course_id}
                                          id={el.course_name}
                                          // checked={course_on.some((element) => {
                                          //   if (element.id == el.course_id) {
                                          //     return true;
                                          //   }
                                          //   return false;
                                          // })}

                                          checked={course_on.some(
                                            (element) =>
                                              element.name === el.course_name
                                          )}
                                          onChange={(e) =>
                                            handleCheckboxChange(e, "course")
                                          }
                                        />
                                        <label
                                          className="form-check-label filterChipText_withoutBG "
                                          htmlFor={el.course_name}
                                        >
                                          {el.course_name}
                                        </label>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                                <div className="borderWidth row">
                                  <ul className="List-Button">
                                    <li className="ListBtnItems">
                                      <Link
                                        to={"javascript:void(0)"}
                                        onClick={() => handleClear("course")}
                                        className="secondaryButton "
                                      >
                                        Clear
                                      </Link>
                                    </li>
                                    <li className="ListBtnItems">
                                      <Link
                                        disabled={
                                          course_on.length === 0 ? true : false
                                        }
                                        onClick={() =>
                                          handleApplyFilter("course")
                                        }
                                        className="primaryButton"
                                      >
                                        Apply Filter
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </>
                          )}
                        </th>
                      )}
                      {activeTab === 0 && (
                        <th
                          id="th"
                          className={StyleInfo.tableThPadding}
                          ref={filterRef_subject}
                        >
                          <span
                            onClick={(e) => handleSort(e, "subject_name")}
                            className="textHead_th"
                          >
                            Subject
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "subject_name")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                          <span
                            className={`textHead_th align-middle material-icons ${
                              subject_on.length > 0
                                ? StyleInfo.active_icons_book
                                : ""
                            } ${
                              isOpen.subject ? StyleInfo.active_icons_book : ""
                            }`} // Change here
                            onClick={(e) => handleFilter(e, "subject")}
                          >
                            filter_list
                          </span>
                          {isOpen.subject && (
                            <>
                              <div className="filterBoxs_testlist mt-3">
                                <div className="col-md-12 form-check filterStatus_list">
                                  <ul className="ulFilterListData">
                                    <li
                                      className={`filterListData ${StyleInfo.searchInputSec}`}
                                    >
                                      <input
                                        className={`${StyleInfo.searchInput} w-100`}
                                        type="text"
                                        placeholder="Search by subject"
                                        name="search_book_title"
                                        onKeyDown={(e) =>
                                          handleFilterCourseSearch(e, "subject")
                                        }
                                        ref={txtBSearch_sub}
                                      />
                                      <Search
                                        onClick={() =>
                                          handleFilterSearchFocus("subject")
                                        }
                                        className={`${StyleInfo.ListsearchIcon}`}
                                      />
                                    </li>
                                    {subjectIds.map((el) => (
                                      <li className="filterListData">
                                        <input
                                          className="ListCheckbox"
                                          type="checkbox"
                                          name={el.subject_name}
                                          value={el.subject_id}
                                          id={el.subject_name}
                                          checked={subject_on.some(
                                            (element) => {
                                              if (element.id == el.subject_id) {
                                                return true;
                                              }
                                              return false;
                                            }
                                          )}
                                          onChange={(e) =>
                                            handleCheckboxChange(e, "subject")
                                          }
                                        />
                                        <label
                                          className="form-check-label filterChipText_withoutBG "
                                          htmlFor={el.subject_name}
                                        >
                                          {el.subject_name}
                                        </label>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                                <div className="borderWidth row">
                                  <ul className="List-Button">
                                    <li className="ListBtnItems">
                                      <Link
                                        to={"javascript:void(0)"}
                                        onClick={() => handleClear("subject")}
                                        className="secondaryButton "
                                      >
                                        Clear
                                      </Link>
                                    </li>
                                    <li className="ListBtnItems">
                                      <Link
                                        disabled={
                                          subject_on.length === 0 ? true : false
                                        }
                                        onClick={() =>
                                          handleApplyFilter("subject")
                                        }
                                        className="primaryButton"
                                      >
                                        Apply Filter
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </>
                          )}
                        </th>
                      )}
                      {activeTab === 1 && (
                        <th
                          id="th"
                          className={StyleInfo.tableThPadding}
                          ref={filterRef_subject}
                        >
                          <span
                            onClick={(e) => handleSort(e, "subject_name")}
                            className="textHead_th"
                          >
                            Subject
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "subject_name")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                          <span
                            className={`textHead_th align-middle material-icons ${
                              subject_on.length > 0
                                ? StyleInfo.active_icons_book
                                : ""
                            } ${
                              isOpen.subject ? StyleInfo.active_icons_book : ""
                            }`} // Change here
                            onClick={(e) => handleFilter(e, "subject")}
                          >
                            filter_list
                          </span>
                          {isOpen.subject && (
                            <>
                              <div className="filterBoxs_testlist mt-3">
                                <div className="col-md-12 form-check filterStatus_list">
                                  <ul className="ulFilterListData">
                                    <li
                                      className={`filterListData ${StyleInfo.searchInputSec}`}
                                    >
                                      <input
                                        className={`${StyleInfo.searchInput} w-100`}
                                        type="text"
                                        placeholder="Search by subject"
                                        name="search_book_title"
                                        onKeyDown={(e) =>
                                          handleFilterCourseSearch(e, "subject")
                                        }
                                        ref={txtBSearch_sub}
                                      />
                                      <Search
                                        onClick={() =>
                                          handleFilterSearchFocus("subject")
                                        }
                                        className={`${StyleInfo.ListsearchIcon}`}
                                      />
                                    </li>
                                    {subjectIds.map((el) => (
                                      <li className="filterListData">
                                        <input
                                          className="ListCheckbox"
                                          type="checkbox"
                                          name={el.subject_name}
                                          value={el.subject_id}
                                          id={el.subject_name}
                                          // checked={subject_on.some((element) => {
                                          //   if (element.id == el.subject_id) {
                                          //     return true;
                                          //   }
                                          //   return false;
                                          // })}
                                          checked={subject_on.some(
                                            (element) =>
                                              element.name === el.subject_name
                                          )}
                                          onChange={(e) =>
                                            handleCheckboxChange(e, "subject")
                                          }
                                        />
                                        <label
                                          className="form-check-label filterChipText_withoutBG "
                                          htmlFor={el.subject_name}
                                        >
                                          {el.subject_name}
                                        </label>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                                <div className="borderWidth row">
                                  <ul className="List-Button">
                                    <li className="ListBtnItems">
                                      <Link
                                        to={"javascript:void(0)"}
                                        onClick={() => handleClear("subject")}
                                        className="secondaryButton "
                                      >
                                        Clear
                                      </Link>
                                    </li>
                                    <li className="ListBtnItems">
                                      <Link
                                        disabled={
                                          subject_on.length === 0 ? true : false
                                        }
                                        onClick={() =>
                                          handleApplyFilter("subject")
                                        }
                                        className="primaryButton"
                                      >
                                        Apply Filter
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </>
                          )}
                        </th>
                      )}

                      <th
                        id="th"
                        className={StyleInfo.tableThPadding}
                        ref={filterRef_medium}
                      >
                        <span
                          onClick={(e) => handleSort(e, "medium")}
                          className="textHead_th"
                        >
                          Medium
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "medium")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                        <span
                          className={`textHead_th align-middle material-icons ${
                            medium_on.length > 0
                              ? StyleInfo.active_icons_book
                              : ""
                          } ${
                            isOpen.medium ? StyleInfo.active_icons_book : ""
                          }`} // Change here
                          onClick={(e) => handleFilter(e, "medium")}
                        >
                          filter_list
                        </span>
                        {isOpen.medium && (
                          <>
                            <div className="filterBoxs_testlist mt-5">
                              <div className="col-md-12 form-check filterStatus_list">
                                <ul className="ulFilterListData">
                                  <li className="filterListData">
                                    <input
                                      className="ListCheckbox"
                                      type="checkbox"
                                      name={"Tamil"}
                                      value={"0"}
                                      checked={medium_on.some((element) => {
                                        if (element.id == "0") {
                                          return true;
                                        }
                                        return false;
                                      })}
                                      id={"medium_Yes"}
                                      onChange={(e) =>
                                        handleCheckboxChange(e, "medium")
                                      }
                                    />
                                    <label
                                      className="form-check-label filterChipText_withoutBG "
                                      htmlFor={"medium_Yes"}
                                    >
                                      Tamil
                                    </label>
                                  </li>
                                  <li className="filterListData">
                                    <input
                                      className="ListCheckbox"
                                      type="checkbox"
                                      name={"English"}
                                      value={"1"}
                                      checked={medium_on.some((element) => {
                                        if (element.id == "1") {
                                          return true;
                                        }
                                        return false;
                                      })}
                                      id={"medium_No"}
                                      onChange={(e) =>
                                        handleCheckboxChange(e, "medium")
                                      }
                                    />
                                    <label
                                      className="form-check-label filterChipText_withoutBG "
                                      htmlFor={"medium_No"}
                                    >
                                      English
                                    </label>
                                  </li>
                                  <li className="filterListData">
                                    <input
                                      className="ListCheckbox"
                                      type="checkbox"
                                      name={"Both"}
                                      value={"2"}
                                      checked={medium_on.some((element) => {
                                        if (element.id == "2") {
                                          return true;
                                        }
                                        return false;
                                      })}
                                      id={"Both"}
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          e,
                                          "medium",
                                          "medium"
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label filterChipText_withoutBG "
                                      htmlFor={"Both"}
                                    >
                                      Both
                                    </label>
                                  </li>
                                </ul>
                              </div>
                              <div className="borderWidth row">
                                <ul className="List-Button">
                                  <li className="ListBtnItems">
                                    <Link
                                      to={"javascript:void(0)"}
                                      onClick={() => handleClear("medium")}
                                      className="secondaryButton "
                                    >
                                      Clear
                                    </Link>
                                  </li>
                                  <li className="ListBtnItems">
                                    <Link
                                      disabled={
                                        medium_on.length === 0 ? true : false
                                      }
                                      onClick={() =>
                                        handleApplyFilter("medium")
                                      }
                                      className="primaryButton"
                                    >
                                      Apply Filter
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </>
                        )}
                      </th>
                      {/* comboOffer, setComboOffer */}
                      {activeTab === 1 && (
                        <th
                          id="th"
                          className={StyleInfo.tableThPadding}
                          ref={filterRef_combo_offer}
                        >
                          <span
                            onClick={(e) => handleSort(e, "is_combo_offer")}
                            className="textHead_th"
                          >
                            Combo Offer
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "is_combo_offer")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                          <span
                            className={`textHead_th align-middle material-icons ${
                              comboOffer.length > 0
                                ? ListInfo.active_icons_book
                                : ""
                            } ${
                              isOpen.is_combo_offer
                                ? ListInfo.active_icons_book
                                : ""
                            }`}
                            onClick={(e) => handleFilter(e, "is_combo_offer")}
                          >
                            filter_list
                          </span>
                          {isOpen.is_combo_offer && (
                            <>
                              <div className="filterBoxs_testlist mt-5">
                                <div className="col-md-12 form-check filterStatus_list">
                                  <ul className="ulFilterListData">
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={"Combo Offer : Yes"}
                                        value={"1"}
                                        id={"is_combo_offer_yes"}
                                        checked={comboOffer?.some((element) => {
                                          if (element.id == "1") {
                                            return true;
                                          }
                                          return false;
                                        })}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            "comboOffer",
                                            "comboOffer"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={"is_combo_offer_yes"}
                                      >
                                        Yes
                                      </label>
                                    </li>
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={"Combo Offer : No"}
                                        value={"0"}
                                        id={"is_combo_offer_no"}
                                        checked={comboOffer?.some((element) => {
                                          if (element.id == "0") {
                                            return true;
                                          }
                                          return false;
                                        })}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            "comboOffer",
                                            "comboOffer"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={"is_combo_offer_no"}
                                      >
                                        No
                                      </label>
                                    </li>
                                  </ul>
                                </div>
                                <div className="borderWidth row">
                                  <ul className="List-Button">
                                    <li className="ListBtnItems">
                                      <Link
                                        to={"javascript:void(0)"}
                                        onClick={() =>
                                          handleClear("comboOffer")
                                        }
                                        className="secondaryButton "
                                      >
                                        Clear
                                      </Link>
                                    </li>
                                    <li className="ListBtnItems">
                                      <Link
                                        disabled={
                                          comboOffer === "" ? true : false
                                        }
                                        onClick={() =>
                                          handleApplyFilter("comboOffer")
                                        }
                                        className="primaryButton"
                                      >
                                        Apply Filter
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </>
                          )}
                        </th>
                      )}
                      {activeTab === 0 && (
                        <th
                          id="th"
                          className={StyleInfo.tableThPadding}
                          ref={filterRef_ebook}
                        >
                          <span
                            onClick={(e) => handleSort(e, "is_ebook")}
                            className="textHead_th"
                          >
                            E-Book
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "is_ebook")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                          <span
                            className={`textHead_th align-middle material-icons ${
                              eBook.length > 0 ? ListInfo.active_icons_book : ""
                            } ${
                              isOpen.is_ebook ? ListInfo.active_icons_book : ""
                            }`}
                            onClick={(e) => handleFilter(e, "is_ebook")}
                          >
                            filter_list
                          </span>
                          {isOpen.is_ebook && (
                            <>
                              <div className="filterBoxs_testlist mt-5">
                                <div className="col-md-12 form-check filterStatus_list">
                                  <ul className="ulFilterListData">
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        value={"1"}
                                        id={"is_ebook_yes"}
                                        name={"E-Book : Yes"}
                                        checked={eBook?.some((element) => {
                                          if (element.id == "1") {
                                            return true;
                                          }
                                          return false;
                                        })}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            "eBook",
                                            "eBook"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={"is_ebook_yes"}
                                      >
                                        Yes
                                      </label>
                                    </li>
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        value={"0"}
                                        id={"is_ebook_no"}
                                        name={"E-Book : No"}
                                        checked={eBook?.some((element) => {
                                          if (element.id == "0") {
                                            return true;
                                          }
                                          return false;
                                        })}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            "eBook",
                                            "eBook"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={"is_ebook_no"}
                                      >
                                        No
                                      </label>
                                    </li>
                                  </ul>
                                </div>
                                <div className="borderWidth row">
                                  <ul className="List-Button">
                                    <li className="ListBtnItems">
                                      <Link
                                        to={"javascript:void(0)"}
                                        onClick={() => handleClear("eBook")}
                                        className="secondaryButton "
                                      >
                                        Clear
                                      </Link>
                                    </li>
                                    <li className="ListBtnItems">
                                      <Link
                                        disabled={eBook === "" ? true : false}
                                        onClick={() =>
                                          handleApplyFilter("eBook")
                                        }
                                        className="primaryButton"
                                      >
                                        Apply Filter
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </>
                          )}
                        </th>
                      )}
                      {/* ++++++++++++++++++++++++++++++++++++++ */}
                      <th
                        id="th"
                        className={ListInfo.tableThPadding}
                        ref={filterRef_series}
                      >
                        <span
                          className="textHead_th"
                          onClick={(e) => handleSort(e, "seriesTag")}
                        >
                          Book Series
                        </span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) => handleSort(e, "seriesTag")}
                        >
                          import_export{" "}
                        </span>
                        <span
                          className={`textHead_th align-middle material-icons ${
                            series_on.length > 0
                              ? ListInfo.active_icons_book
                              : ""
                          } ${
                            isOpen.seriesTag ? ListInfo.active_icons_book : ""
                          }`} // Change here
                          onClick={(e) => handleFilter(e, "seriesTag")}
                        >
                          filter_list
                        </span>
                        {isOpen.seriesTag && (
                          <>
                            <div className="filterBoxs_testlist mt-3">
                              <div className="col-md-12 form-check filterStatus_list">
                                <ul className="ulFilterListData">
                                  {Tagsitems.map((el) => (
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={el.tag_name}
                                        value={el.tag_id}
                                        id={el.tag_name}
                                        checked={series_on.some((element) => {
                                          if (element.id == el.tag_id) {
                                            return true;
                                          }
                                          return false;
                                        })}
                                        onChange={(e) =>
                                          handleCheckboxChange(e, "seriesTag")
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={el.tag_name}
                                      >
                                        {el.tag_name}
                                      </label>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                              <div className="borderWidth row">
                                <ul className="List-Button">
                                  <li className="ListBtnItems">
                                    <Link
                                      to={"javascript:void(0)"}
                                      onClick={() => handleClear("seriesTag")}
                                      className="secondaryButton "
                                    >
                                      Clear
                                    </Link>
                                  </li>
                                  <li className="ListBtnItems">
                                    <Link
                                      disabled={
                                        series_on.length === 0 ? true : false
                                      }
                                      onClick={() =>
                                        handleApplyFilter("seriesTag")
                                      }
                                      className="primaryButton"
                                    >
                                      Apply Filter
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </>
                        )}
                      </th>
                      {/* ++++++++++++++++++++++++++++++++++++++ */}
                      {activeTab === 1 && (
                        <th
                          id="th"
                          className={ListInfo.tableThPadding}
                          ref={filterAvalible_to_user}
                        >
                          <div class={ListInfo.thcontent}>
                            <span
                              onClick={(e) => handleSort(e, "availableToUser")}
                              class="textHead_th"
                            >
                              Available <br /> to Users
                            </span>
                            <div class={ListInfo.iconcontainer}>
                              <span
                                onClick={(e) =>
                                  handleSort(e, "availableToUser")
                                }
                                className={`textHead_th material-icons align-middle`}
                              >
                                import_export{" "}
                              </span>
                              <span
                                className={`textHead_th align-middle material-icons ${
                                  availableToUser.length > 0
                                    ? ListInfo.active_icons_book
                                    : ""
                                } ${
                                  isOpen.availableToUser
                                    ? ListInfo.active_icons_book
                                    : ""
                                }`} // Change here
                                onClick={(e) =>
                                  handleFilter(e, "availableToUser")
                                }
                              >
                                filter_list
                              </span>
                            </div>
                          </div>
                          {isOpen.availableToUser && (
                            <>
                              <div className="filterBoxs_testlist mt-3">
                                <div className="col-md-12 form-check filterStatus_list">
                                  <ul className="ulFilterListData">
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={"Available to Users : Yes"}
                                        value={"1"}
                                        checked={availableToUser.some(
                                          (element) => {
                                            if (element.id == "1") {
                                              return true;
                                            }
                                            return false;
                                          }
                                        )}
                                        id={"availableToUser_yes"}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            "availableToUser"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={"availableToUser_yes"}
                                      >
                                        Yes
                                      </label>
                                    </li>
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={"Available to Users : No"}
                                        value={"0"}
                                        checked={availableToUser.some(
                                          (element) => {
                                            if (element.id == "0") {
                                              return true;
                                            }
                                            return false;
                                          }
                                        )}
                                        id={"availableToUser_no"}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            "availableToUser"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={"availableToUser_no"}
                                      >
                                        No
                                      </label>
                                    </li>
                                  </ul>
                                </div>
                                <div className="borderWidth row">
                                  <ul className="List-Button">
                                    <li className="ListBtnItems">
                                      <Link
                                        to={"javascript:void(0)"}
                                        onClick={() =>
                                          handleClear("availableToUser")
                                        }
                                        className="secondaryButton "
                                      >
                                        Clear
                                      </Link>
                                    </li>
                                    <li className="ListBtnItems">
                                      <Link
                                        // disabled={
                                        //   availableToUser.length === 0
                                        //     ? true
                                        //     : false
                                        // }
                                        onClick={() =>
                                          handleApplyFilter("availableToUser")
                                        }
                                        className="primaryButton"
                                      >
                                        Apply Filter
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </>
                          )}
                        </th>
                      )}
                      <th
                        id="th"
                        className={ListInfo.tableThPadding}
                        ref={filterRef_mrp}
                      >
                        <span
                          className="textHead_th"
                          onClick={(e) => handleSort(e, "price")}
                        >
                          MRP
                        </span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) => handleSort(e, "price")}
                        >
                          import_export{" "}
                        </span>
                        <span
                          className={`textHead_th align-middle material-icons ${
                            mrp.fromDate || mrp.toDate || isOpen.price
                              ? ListInfo.active_icons_book
                              : ""
                          } `} // Change here
                          onClick={(e) => handleFilter(e, "price")}
                        >
                          filter_list
                        </span>
                        {isOpen.price === true && (
                          <div className="filterBoxs p-1 mt-3">
                            <div className="row ">
                              <div className="col-md-12">
                                <div>
                                  <div>
                                    <label
                                      for="bookName"
                                      class="form-label confirm_value "
                                    >
                                      From
                                    </label>
                                  </div>
                                  <input
                                    class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                                    type="number"
                                    id="fromDate"
                                    name="fromDate"
                                    onWheel={(e) => e.target.blur()}
                                    placeholder="Enter the from price"
                                    value={mrp.fromDate}
                                    onChange={handlePriceChange}
                                  />
                                </div>
                                <div>
                                  <div>
                                    <label
                                      for="bookName"
                                      class="form-label confirm_value "
                                    >
                                      To
                                    </label>
                                  </div>
                                  <input
                                    class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                                    type="number"
                                    id="toDate"
                                    name="toDate"
                                    onWheel={(e) => e.target.blur()}
                                    placeholder="Enter the to price"
                                    value={mrp.toDate}
                                    onChange={handlePriceChange}
                                  />
                                </div>
                                {/* <div class="form-check">
                                                                 <MultiRangeSlider
                                                                   handleChangeFilter={handleChangeFilter}
                                                                   ranges={ranges}
                                                                 />
                                                               </div> */}
                              </div>
                            </div>
                            <hr />
                            <div className="row mt-3">
                              <div className="col-md-4  col-4 col-sm-4">
                                <span
                                  className="clearFilter ms-2 "
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleClear("price")}
                                >
                                  Clear
                                </span>
                              </div>
                              <div className="col-md-8  col-8 col-sm-8">
                                <button
                                  className="FilterButton"
                                  onClick={() => handleApplyFilter("price")}
                                >
                                  Apply Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </th>

                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span
                          onClick={(e) => handleSort(e, "offer_percentage")}
                          className="textHead_th"
                        >
                          Offer %
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "offer_percentage")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                      </th>

                      <th id="th" className={StyleInfo.tableThPadding}>
                        <div class={StyleInfo.thcontent}>
                          <span
                            onClick={(e) => handleSort(e, "finalPrice")}
                            className="textHead_th"
                          >
                            Final
                            <br /> Price
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "finalPrice")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export
                          </span>
                        </div>
                      </th>

                      <th id="th" className={StyleInfo.tableThPadding}>
                        <div class={StyleInfo.thcontent}>
                          <span
                            onClick={(e) => handleSort(e, "weight")}
                            className="textHead_th"
                          >
                            Weight
                            <br /> (in kg)
                          </span>
                          <span
                            onClick={(e) => handleSort(e, "weight")}
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </div>
                      </th>

                      {activeTab === 0 && (
                        <th id="th" className={StyleInfo.tableThPadding}>
                          <div class={StyleInfo.thcontent}>
                            <span
                              onClick={(e) => handleSort(e, "stock_count")}
                              className="textHead_th"
                            >
                              Stock
                              <br /> Count
                            </span>
                            <span
                              onClick={(e) => handleSort(e, "stock_count")}
                              className={`textHead_th material-icons align-middle`}
                            >
                              import_export
                            </span>
                          </div>
                        </th>
                      )}
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span className="textHead_th">Action</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentData?.length === 0 ? (
                      <tr>
                        <td colspan="15" style={{ textAlign: "center" }}>
                          No records to display
                        </td>
                      </tr>
                    ) : (
                      currentData?.map((book) => (
                        <tr
                          key={book.id}
                          className={
                            book.stock_count < 0 ? StyleInfo.redRow : ""
                          }
                        >
                          <td>
                            <input
                              className={`${StyleInfo.checkBox_input}
                                  ${
                                    (book.stock_count === 0 &&
                                      book.is_ebbok === 1) ||
                                    (book.stock_count &&
                                      book.is_ebbok == 0 <= 0 &&
                                      activeTab === 0) ||
                                    book.availableToUser == 0 ||
                                    book.is_visible === 0
                                      ? "disabled_btn"
                                      : ""
                                  }
                                  `}
                              style={{
                                opacity:
                                  (book.stock_count === 0 &&
                                    book.is_ebbok === 1) ||
                                  (book.stock_count &&
                                    book.is_ebbok == 0 <= 0 &&
                                    activeTab === 0) ||
                                  book.availableToUser == 0 ||
                                  book.is_visible === 0
                                    ? 0.2
                                    : "",
                              }}
                              checked={selectedBooks.includes(book.id)}
                              type="checkbox"
                              name="bookset_order"
                              disabled={
                                book.is_visible === 0 ||
                                book.availableToUser === 0 ||
                                (book.is_ebook === 0 &&
                                  book.is_visible === 1 &&
                                  book.is_set === 0 &&
                                  book.stock_count === 0)
                              }
                              id={`bookset_order_${book.id}`}
                              value={book.id}
                              onChange={(e) =>
                                handleChangeBookOrder(e, book.id, book)
                              }
                            />
                          </td>
                          <td id="td">{book.serialNumber}</td>
                          <td id="td">
                            <span
                              title={book.book_title}
                              className={StyleInfo.ellipsisText}
                            >
                              {book.book_title}
                            </span>
                          </td>
                          {activeTab === 0 && (
                            <>
                              <td id="td">
                                {" "}
                                <span
                                  title={book.author}
                                  className={StyleInfo.ellipsisText}
                                >
                                  {book.author ? book.author : "_"}
                                </span>
                              </td>
                              <td id="td">
                                <span
                                  title={book.publisher}
                                  className={StyleInfo.ellipsisText}
                                >
                                  {book.publisher ? book.publisher : "_"}
                                </span>
                              </td>
                            </>
                          )}

                          {activeTab === 1 && (
                            <td id="td">{book.totalBooksCount}</td>
                          )}
                          <td id="td">{book.is_visible ? "Yes" : "No"}</td>
                          <td id="td">
                            {book.category_name ? book.category_name : "_"}
                          </td>
                          <td id="td">
                            <span
                              title={book.group_course_name}
                              className={StyleInfo.ellipsisText}
                            >
                              {book.group_course_name
                                ? book.group_course_name
                                : "_"}
                            </span>
                          </td>
                          <td id="td">
                            <span
                              title={book.subject_name}
                              className={StyleInfo.ellipsisText}
                            >
                              {book.subject_name ? book.subject_name : "_"}
                            </span>
                          </td>
                          <td id="td">{book.medium ? book.medium : "_"}</td>
                          {activeTab === 1 && (
                            <td id="td">
                              {book.is_combo_offer === 0 ? "No" : "Yes"}
                            </td>
                          )}
                          {activeTab === 0 && (
                            <td id="td">
                              {book.is_ebook === 0 ? "No" : "Yes"}
                            </td>
                          )}
                          <td id="td">{book.series_name || "_"}</td>
                          {activeTab === 1 && (
                            <td id="td">
                              {book.availableToUser == 1 ? "Yes" : "No"}
                            </td>
                          )}
                          <td id="td">{book.price ? book.price : "0"}</td>
                          <td id="td">{book.offer_percentage || 0}</td>
                          <td id="td">
                            {book.finalPrice ? book.finalPrice : "0"}
                          </td>
                          <td id="td">
                            {book.weight
                              ? parseFloat(book.weight).toFixed(3)
                              : "0"}
                          </td>

                          {activeTab === 0 && (
                            <td id="td">{book.stock_count}</td>
                          )}
                          <td id="td">
                            <img
                              src={ViewIcon}
                              className={StyleInfo.cursor_pointer}
                              onClick={() => {
                                handleView(book.id, book.is_set, book.book_ids);
                              }}
                              alt="view icon"
                            />
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="row mt-2">
              <Pagination
                rowsPerPage={rowsPerPage}
                handlePageCount={handlePageCount}
                startPage={
                  updateListData && updateListData?.length > 0
                    ? currentPage * rowsPerPage + 1 - rowsPerPage
                    : 0
                }
                endPage={
                  updateListData && updateListData?.length > 0
                    ? updateListData?.length < currentPage * rowsPerPage
                      ? updateListData?.length
                      : currentPage * rowsPerPage
                    : 0
                }
                totalRecords={
                  updateListData && updateListData?.length > 0
                    ? updateListData?.length
                    : 0
                }
                handlePrev={(e) => handlePrev(currentPage - 1)}
                currentPrevPage={currentPage === 1}
                prevButton={`${StyleInfo.prev_buttonViewAllbook} ${StyleInfo.materialIconsRightAndLeft} me-2`}
                handleNext={() => handleNext(currentPage + 1)}
                currentNextPage={currentPage === totalPages || totalPages == 0}
              />
            </div>
          </fieldset>
        </div>
        <div className="row m-0 mb-4">
          <fieldset className="mt-3">
            <legend className="w-auto mb-0">Selected Books</legend>
            <div className="col-md-3 col-12 mt-3 ">
              <div class={StyleInfo.searchInputSec}>
                <form onSubmit={handleSearchSubmit}>
                  <input
                    className={`${StyleInfo.searchInput} w-100`}
                    type="text"
                    placeholder="Scan barcode here..."
                    name="bar_code_search"
                    // autoFocus
                    value={barcode}
                    onChange={handleScan}
                  />
                </form>
              </div>
            </div>
            <div className="row mx-0 mt-4">
              <div className="col-md-12 table-responsive tableMinHeight px-0">
                <table className="table" id="tableListHeader">
                  <thead>
                    <tr>
                      {/* <th id="th" className={StyleInfo.tableThPadding}></th> */}
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span
                          className="textHead_th"
                          onClick={(e) =>
                            SortSelectedBooksAndBookSet(e, "seriesNumber")
                          }
                        >
                          S.No.
                        </span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) =>
                            SortSelectedBooksAndBookSet(e, "seriesNumber")
                          }
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span
                          className="textHead_th"
                          onClick={(e) =>
                            SortSelectedBooksAndBookSet(e, "book_title")
                          }
                        >
                          Book Name
                        </span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) =>
                            SortSelectedBooksAndBookSet(e, "book_title")
                          }
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span
                          className="textHead_th"
                          onClick={(e) =>
                            SortSelectedBooksAndBookSet(e, "author")
                          }
                        >
                          Author
                        </span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) =>
                            SortSelectedBooksAndBookSet(e, "author")
                          }
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span
                          className="textHead_th"
                          onClick={(e) =>
                            SortSelectedBooksAndBookSet(e, "publisher")
                          }
                        >
                          Publisher
                        </span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) =>
                            SortSelectedBooksAndBookSet(e, "publisher")
                          }
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span
                          className="textHead_th"
                          onClick={(e) =>
                            SortSelectedBooksAndBookSet(e, "category_name")
                          }
                        >
                          Category
                        </span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) =>
                            SortSelectedBooksAndBookSet(e, "category_name")
                          }
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span
                          className="textHead_th"
                          onClick={(e) =>
                            SortSelectedBooksAndBookSet(e, "group_course_name")
                          }
                        >
                          Course
                        </span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) =>
                            SortSelectedBooksAndBookSet(e, "group_course_name")
                          }
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span
                          className="textHead_th"
                          onClick={(e) =>
                            SortSelectedBooksAndBookSet(e, "subject_name")
                          }
                        >
                          Subject
                        </span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) =>
                            SortSelectedBooksAndBookSet(e, "subject_name")
                          }
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span
                          className="textHead_th"
                          onClick={(e) =>
                            SortSelectedBooksAndBookSet(e, "medium")
                          }
                        >
                          Medium
                        </span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) =>
                            SortSelectedBooksAndBookSet(e, "medium")
                          }
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <div class={ListInfo.thcontent}>
                          <span
                            className="textHead_th"
                            onClick={(e) =>
                              SortSelectedBooksAndBookSet(e, "is_set")
                            }
                          >
                            Individual / <br /> Bookset
                          </span>
                          <span
                            className={`textHead_th material-icons align-middle`}
                            onClick={(e) =>
                              SortSelectedBooksAndBookSet(e, "is_set")
                            }
                          >
                            import_export{" "}
                          </span>
                        </div>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <div class={StyleInfo.thcontent}>
                          <span
                            onClick={(e) =>
                              SortSelectedBooksAndBookSet(e, "weight")
                            }
                            className="textHead_th"
                          >
                            Weight
                            <br /> (in kg)
                          </span>
                          <span
                            onClick={(e) =>
                              SortSelectedBooksAndBookSet(e, "weight")
                            }
                            className={`textHead_th material-icons align-middle`}
                          >
                            import_export{" "}
                          </span>
                        </div>
                      </th>{" "}
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <div class={ListInfo.thcontent}>
                          <span
                            className="textHead_th"
                            onClick={(e) =>
                              SortSelectedBooksAndBookSet(e, "finalPrice")
                            }
                          >
                            Final
                            <br /> Price
                          </span>
                          <span
                            className={`textHead_th material-icons align-middle`}
                            onClick={(e) =>
                              SortSelectedBooksAndBookSet(e, "finalPrice")
                            }
                          >
                            import_export{" "}
                          </span>
                        </div>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span className="textHead_th"> Quantity</span>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span className="textHead_th"> Student Price</span>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span className="textHead_th">Action</span>
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {paginatedBooks?.length == 0 ? (
                      <tr>
                        <td colSpan="15" style={{ textAlign: "center" }}>
                          No records to display
                        </td>
                      </tr>
                    ) : (
                      paginatedBooks?.length > 0 &&
                      paginatedBooks?.map((book, index) => (
                        <tr key={book.id}>
                          {/* <td id="td">{book.serialNumber}</td> */}
                          <td id="td">
                            <input
                              className={StyleInfo.checkBox_input}
                              checked={selectedBooks.includes(book.id)}
                              type="checkbox"
                              name="bookset_order"
                              id={`bookset_order_${book.id}`}
                              value={book.id}
                              onChange={(e) =>
                                handleChangeBookOrder(e, book.id, book)
                              }
                            />
                            &nbsp;&nbsp;{book.seriesNumber}
                          </td>
                          <td id="td">
                            <span
                              title={book.book_title}
                              className={StyleInfo.ellipsisText}
                            >
                              {book.book_title}
                            </span>
                          </td>
                          <td id="td">
                            {" "}
                            <span
                              title={book.author}
                              className={StyleInfo.ellipsisText}
                            >
                              {book.author ? book.author : "_"}
                            </span>
                          </td>
                          <td id="td">
                            <span
                              title={book.publisher}
                              className={StyleInfo.ellipsisText}
                            >
                              {book.publisher ? book.publisher : "_"}
                            </span>
                          </td>
                          <td id="td">
                            {book.category_name ? book.category_name : "_"}
                          </td>
                          <td id="td">
                            <span
                              title={book.group_course_name}
                              className={StyleInfo.ellipsisText}
                            >
                              {book.group_course_name
                                ? book.group_course_name
                                : "_"}
                            </span>
                          </td>
                          <td id="td">
                            <span
                              title={book.subject_name}
                              className={StyleInfo.ellipsisText}
                            >
                              {book.subject_name ? book.subject_name : "_"}
                            </span>
                          </td>
                          <td id="td">{book.medium ? book.medium : "_"}</td>
                          <td id="td">
                            {book.is_set === 0
                              ? "Individual"
                              : "Bookset" || "-"}
                          </td>
                          <td id="td">
                            {book.weight
                              ? parseFloat(book.weight).toFixed(3)
                              : "0"}
                          </td>

                          <td id="td">
                            {book.finalPrice ? book.finalPrice : "0"}
                          </td>

                          {freeBook || book.is_ebook === 1 ? (
                            <td id="td">{"1"}</td>
                          ) : (
                            <td>
                              <div>
                                <select
                                  id={`quantity${book.id}`}
                                  name="quantity"
                                  value={book?.quantity || 1}
                                  onChange={(e) =>
                                    handleQuantityChange(
                                      e,
                                      book.id,
                                      book.stock_count,
                                      book.weight,
                                      book.is_set
                                    )
                                  }
                                  disabled={isQuantityDisabled[book.id]}
                                  className={` ${
                                    isQuantityDisabled[book.id]
                                      ? "bg-gray-200 cursor-not-allowed"
                                      : ""
                                  }`}
                                >
                                  <option value="" disabled>
                                    Select
                                  </option>{" "}
                                  {Array.from(
                                    {
                                      length:
                                        book.availableToUser === 1
                                          ? 50
                                          : Math.min(book.stock_count || 0, 50),
                                    },
                                    (_, i) => (
                                      <option key={i + 1} value={i + 1}>
                                        {i + 1}
                                      </option>
                                    )
                                  )}
                                </select>
                              </div>
                              {error[book.id]?.quantity &&
                                typeof error[book.id]?.quantity ===
                                  "string" && (
                                  <span className="error-message">
                                    {error[book.id]?.quantity}
                                  </span>
                                )}
                            </td>
                          )}

                          <td id="td">
                            <div>
                              <span>
                                {initialfields[book.id]?.freeBook === "yes"
                                  ? 0
                                  : initialfields[book.id]?.quantity *
                                      book.finalPrice || book.finalPrice}
                              </span>
                            </div>
                          </td>
                          <td id="td">
                            <img
                              src={ViewIcon}
                              className={StyleInfo.cursor_pointer}
                              alt="view icon"
                              onClick={() => {
                                handleView(book.id, book.is_set, book.book_ids);
                              }}
                            />
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="row mt-2">
              <Pagination
                rowsPerPage={rowsPerPageTwo}
                handlePageCount={handlePageCountTwo}
                startPage={selectedBooks.length > 0 ? startIndexOne + 1 : 0}
                endPage={
                  selectedBooks.length > 0
                    ? Math.min(endIndexOne, selectedBooks.length)
                    : 0
                }
                totalRecords={selectedBooks.length}
                handlePrev={handlePrevTwo}
                currentPrevPage={currentPageTwo === 1}
                prevButton={`${StyleInfo.prev_buttonViewAllbook} ${StyleInfo.materialIconsRightAndLeft} me-2`}
                handleNext={handleNextTwo}
                currentNextPage={currentPageTwo >= totalPagesTwo}
              />
            </div>
          </fieldset>
        </div>

        <div className="row m-0 mb-4">
          <fieldset className="mt-3">
            <legend className="w-auto mb-0">Pre-order Books</legend>
            <div className="row mx-0 mt-4">
              <div className="col-md-12 table-responsive tableMinHeight px-0">
                <table className="table" id="tableListHeader">
                  <thead>
                    <tr>
                      {/* <th id="th" className={StyleInfo.tableThPadding}></th> */}
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span
                          className="textHead_th"
                          onClick={(e) => SortSelectedBooks(e, "seriesNumber")}
                        >
                          S.No.
                        </span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) => SortSelectedBooks(e, "seriesNumber")}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span
                          className="textHead_th"
                          onClick={(e) => SortSelectedBooks(e, "book_title")}
                        >
                          Book Name
                        </span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) => SortSelectedBooks(e, "book_title")}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span
                          className="textHead_th"
                          onClick={(e) => SortSelectedBooks(e, "author")}
                        >
                          Author
                        </span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) => SortSelectedBooks(e, "author")}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span
                          className="textHead_th"
                          onClick={(e) => SortSelectedBooks(e, "publisher")}
                        >
                          Publisher
                        </span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) => SortSelectedBooks(e, "publisher")}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <div class={ListInfo.thcontent}>
                          <span
                            className="textHead_th"
                            onClick={(e) =>
                              SortSelectedBooks(e, "book_set_name")
                            }
                          >
                            Bookset Name
                          </span>
                          <span
                            className={`textHead_th material-icons align-middle`}
                            onClick={(e) =>
                              SortSelectedBooks(e, "book_set_name")
                            }
                          >
                            import_export{" "}
                          </span>
                        </div>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span
                          className="textHead_th"
                          onClick={(e) => SortSelectedBooks(e, "category_name")}
                        >
                          Category
                        </span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) => SortSelectedBooks(e, "category_name")}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span
                          className="textHead_th"
                          onClick={(e) =>
                            SortSelectedBooks(e, "group_course_name")
                          }
                        >
                          Course
                        </span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) =>
                            SortSelectedBooks(e, "group_course_name")
                          }
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span
                          className="textHead_th"
                          onClick={(e) => SortSelectedBooks(e, "subject_name")}
                        >
                          Subject
                        </span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) => SortSelectedBooks(e, "subject_name")}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      <th id="th" className={StyleInfo.tableThPadding}>
                        <span className="textHead_th">Action</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {allBookList?.length === 0 ||
                    !allBookList?.some((book) => book.pre_order?.length > 0) ? (
                      <tr>
                        <td colSpan="15" style={{ textAlign: "center" }}>
                          No records to display
                        </td>
                      </tr>
                    ) : (
                      paginatedRows?.map(
                        (item, index) => (
                          // book.pre_order?.map((item) => (
                          <tr key={item.id}>
                            <td id="td">{item.seriesNumber}</td>
                            <td id="td">
                              <span
                                title={item.book_title}
                                className={StyleInfo.ellipsisText}
                              >
                                {item.book_title}
                              </span>
                            </td>
                            <td id="td">
                              {" "}
                              <span
                                title={item.author}
                                className={StyleInfo.ellipsisText}
                              >
                                {item.author ? item.author : "_"}
                              </span>
                            </td>
                            <td id="td">
                              <span
                                title={item.publisher}
                                className={StyleInfo.ellipsisText}
                              >
                                {item.publisher ? item.publisher : "_"}
                              </span>
                            </td>
                            <td id="td">
                              <span
                                title={item.book_set_name}
                                className={StyleInfo.ellipsisText}
                              >
                                {item.book_set_name ? item.book_set_name : "_"}
                              </span>
                            </td>
                            <td id="td">
                              {item.category_name ? item.category_name : "_"}
                            </td>
                            <td id="td">
                              <span
                                title={item.group_course_name}
                                className={StyleInfo.ellipsisText}
                              >
                                {item.group_course_name
                                  ? item.group_course_name
                                  : "_"}
                              </span>
                            </td>
                            <td id="td">
                              <span
                                title={item.subject_name}
                                className={StyleInfo.ellipsisText}
                              >
                                {item.subject_name ? item.subject_name : "_"}
                              </span>
                            </td>

                            <td id="td">
                              <img
                                src={ViewIcon}
                                className={StyleInfo.cursor_pointer}
                                alt="view icon"
                                onClick={() => {
                                  handleView(
                                    item.book_id,
                                    0,
                                    item.book_ids
                                  );
                                }}
                              />
                            </td>
                          </tr>
                        )
                        // ))
                      )
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="row mt-2">
              <Pagination
                rowsPerPage={rowsPerPageThree}
                handlePageCount={handlePageCountThree}
                startPage={
                  sortedRows.length > 0
                    ? (currentPageThree - 1) * rowsPerPageThree + 1
                    : 0
                }
                endPage={
                  sortedRows.length > 0
                    ? Math.min(
                        currentPageThree * rowsPerPageThree,
                        sortedRows.length
                      )
                    : 0
                }
                totalRecords={preOrderRows.length}
                handlePrev={handlePrevThree}
                currentPrevPage={currentPageThree === 1}
                prevButton={`${StyleInfo.prev_buttonViewAllbook} ${StyleInfo.materialIconsRightAndLeft} me-2`}
                handleNext={handleNextThree}
                currentNextPage={currentPageThree >= totalPagesThree}
              />
            </div>
          </fieldset>
        </div>
        <div className="row m-0 mb-4">
          <fieldset className="mt-3">
            <legend className="w-auto">Payment Details</legend>
            <form className="row g-3">
              <div class={`col-md-6  ${createInfo.inputDisable}`}>
                <label for="actualPrice" class="form-label confirm_value ">
                  Actual Price
                </label>
                <input
                  ref={actualPrice_ref}
                  class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                  type="text"
                  id="actualPrice"
                  name="actualPrice"
                  disabled
                  placeholder="Enter the autual price"
                  value={basePrice}
                  style={{
                    cursor: "not-allowed",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                  onChange={handleChange}
                />
                {error.actualPrice && (
                  <small className="error_message">{error.actualPrice}</small>
                )}
              </div>
              <div class={`col-md-6  ${createInfo.inputDisable}`}>
                <label for="specialOffer" class="form-label confirm_value ">
                  Special Offer
                </label>
                <input
                  ref={specialOffer_ref}
                  class={`desc_input_text w-100 rounded-2 input-font-size-sm
                    `} //new style added
                  type="text"
                  id="specialOffer"
                  name="specialOffer"
                  disabled
                  placeholder="Enter the special offer"
                  value={totalFinalPrice}
                  style={{
                    cursor: "not-allowed",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                  onChange={handleChange}
                />
                {error.specialOffer && (
                  <small className="error_message">{error.specialOffer}</small>
                )}
              </div>

              {freeBook === 0 && (
                <div class="col-md-6 input">
                  <label
                    for="coupon_code"
                    class={`form-label confirm_value ${
                      userCheck ? "text" : createInfo.inputDisable
                    } `}
                  >
                    Coupon Code
                  </label>
                  <div className="d-flex">
                    <div className={createInfo.inputWidth}>
                      <input
                        ref={couponCode_ref}
                        class={`desc_input_text w-100 rounded-2 input-font-size-sm ${
                          userCheck ? "text" : createInfo.inputDisable
                        }
                    `} //new style added
                        type="text"
                        id="coupon_code"
                        name="coupon_code"
                        disabled={!userCheck || freeBook === 1}
                        style={{
                          cursor: userCheck ? "text" : "not-allowed",
                        }}
                        placeholder="Enter the coupon code"
                        value={initialfields.coupon_code}
                        onChange={handleChange}
                      />
                      {listErrors.coupon_code &&
                        couponApplied.status !== true && (
                          <p className="errors mx-0 my-1">
                            {listErrors.coupon_code}
                          </p>
                        )}
                      {couponApplied.status === false && (
                        <p className="errors mx-0 my-1">{message}</p>
                      )}
                    </div>
                    <div className="" style={{ paddingLeft: "20px" }}>
                      <Link
                        to="javascript:void(0)"
                        onClick={userCheck ? handleApplyCoupon : null}
                        className={`primaryButton text-center ${
                          createInfo.applyaBtnWidth
                        } ${userCheck ? "text" : createInfo.inputDisable}`}
                        variant="primary"
                        disabled={!userCheck || freeBook === 1}
                        // aria-disabled={!userCheck || freeBook === 1}
                      >
                        Apply
                      </Link>
                    </div>
                  </div>
                  {error.coupon_code && (
                    <small className="error_message">{error.coupon_code}</small>
                  )}
                  <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                    {couponApplied.status === true && (
                      <h6 className="payment_fees mb-0">
                        <span
                          className="text-success ms-2"
                          style={{ fontSize: "14px" }}
                        >
                          (Coupon code applied successfully)
                        </span>
                      </h6>
                    )}
                  </div>
                </div>
              )}

              <div class={`col-md-6  ${createInfo.inputDisable}`}>
                <label for="CouponAmount" class="form-label confirm_value ">
                  Coupon Code Amount
                </label>
                {/* {couponApplied.status === true && ( */}
                <input
                  ref={couponAmount_ref}
                  class={`desc_input_text w-100 rounded-2 input-font-size-sm
                     `} //new style added
                  type="text"
                  id="CouponAmount"
                  name="CouponAmount"
                  disabled
                  style={{
                    cursor: "not-allowed",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                  placeholder="Enter the coupon code amount"
                  value={couponApplied.amount}
                  onChange={handleChange}
                />
                {/* // )} */}

                {error.CouponAmount && (
                  <small className="error_message">{error.CouponAmount}</small>
                )}
              </div>
              {freeBook === 0 && (
                <div class="col-md-6 input">
                  <label
                    for="rewardPoints"
                    class={`form-label confirm_value   ${
                      userCheck ? "text" : createInfo.inputDisable
                    }`}
                  >
                    Reward Points (In Rupees)
                  </label>
                  <div className="d-flex">
                    <div className={createInfo.inputWidth}>
                      <input
                        ref={rewardPoints_ref}
                        class={`desc_input_text w-100 rounded-2 input-font-size-sm  ${
                          userCheck ? "text" : createInfo.inputDisable
                        }
                    `}
                        type="text"
                        disabled={!userCheck || freeBook === 1}
                        style={{
                          cursor: userCheck ? "text" : "not-allowed",
                        }}
                        id="rewardPoints"
                        name="rewardPoints"
                        placeholder="Enter the reward points"
                        value={initialfields.rewardPoints}
                        onChange={handleChange}
                      />
                      {listErrors.rewardPoints && (
                        <p
                          // style={{ textAlign: "center" }}
                          className="errors mx-0 my-1"
                        >
                          {listErrors.rewardPoints}
                        </p>
                      )}
                      {rewardsnApplied.status === false && (
                        <p
                          // style={{ textAlign: "center" }}
                          className="errors mx-0 my-1"
                        >
                          {rewardMessage}
                        </p>
                      )}
                    </div>
                    <div className="" style={{ paddingLeft: "20px" }}>
                      <Link
                        to="javascript:void(0)"
                        onClick={userCheck ? handleApplyReward : null}
                        className={`primaryButton text-center ${
                          createInfo.applyaBtnWidth
                        } ${userCheck ? "text" : createInfo.inputDisable}`}
                        variant="primary"
                        aria-disabled={!userCheck || freeBook === 1}
                      >
                        Apply
                      </Link>
                    </div>
                  </div>
                  {error.rewardPoints && (
                    <small className="error_message">
                      {error.rewardPoints}
                    </small>
                  )}
                  <div className="col-6 col-sm-5 col-lg-6 col-md-6">
                    {rewardsnApplied.status === true && (
                      <h6 className="payment_fees mb-0">
                        {/* <CurrencyRupee className="payment_currency" />
                      <span className="">{rewardsnApplied.amount}</span> */}
                        <span
                          className="text-success ms-2"
                          style={{ fontSize: "14px" }}
                        >
                          (Reward points applied successfully)
                        </span>
                      </h6>
                    )}
                  </div>
                </div>
              )}

              <div class={`col-md-6  ${createInfo.inputDisable}`}>
                <label for="totalDiscount" class="form-label confirm_value ">
                  Total Discount
                </label>

                <input
                  ref={totalDiscount_ref}
                  class={`desc_input_text w-100 rounded-2 input-font-size-sm `}
                  type="text"
                  id="totalDiscount"
                  name="totalDiscount"
                  disabled
                  style={{
                    cursor: "not-allowed",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                  placeholder="Enter the total amount"
                  value={
                    (totalFinalPrice || 0) +
                    (couponApplied.amount || 0) +
                    (rewardsnApplied.status ? Number(rewardAmount) : 0)
                  }
                  onChange={handleChange}
                />
                {error.totalDiscount && (
                  <small className="error_message">{error.totalDiscount}</small>
                )}
              </div>

              <div class={`col-md-6  ${createInfo.inputDisable}`}>
                <label for="totalDiscount" class="form-label confirm_value ">
                  Amount Payable
                </label>
                <input
                  ref={totalDiscount_ref}
                  class={`desc_input_text w-100 rounded-2 input-font-size-sm `}
                  type="text"
                  id="totalDiscount"
                  name="totalDiscount"
                  disabled
                  style={{
                    cursor: "not-allowed",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                  placeholder="Enter the total amount"
                  value={
                    basePrice -
                    (Number(couponApplied.amount) +
                      parseInt(
                        rewardsnApplied.status === true ? rewardAmount : 0
                      ) +
                      Number(totalFinalPrice))
                  }
                />
                {error.totalDiscount && (
                  <small className="error_message">{error.totalDiscount}</small>
                )}
              </div>
              {initialfields.deliveryMode === 1 && (
                <div class={`col-md-6  `}>
                  <label
                    for="CourierCharges"
                    class={`form-label confirm_value ${createInfo.inputDisable}`}
                  >
                    Courier Charges ({CourierCharges}kg)
                  </label>
                  <input
                    ref={coureieCharges_ref}
                    class={`desc_input_text w-100 rounded-2 input-font-size-sm ${createInfo.inputDisable}`}
                    type="text"
                    disabled
                    style={{
                      cursor: "not-allowed",
                      fontSize: "16px",
                      fontWeight: "bold",
                    }}
                    id="CourierCharges"
                    name="CourierCharges"
                    placeholder="Enter the courier charges"
                    value={
                      freeBook === 1
                        ? 0
                        : paginatedBooks?.length > 0
                        ? courierCharge?.amount || 0
                        : 0
                    }
                    // value={calculateCourierCharge(CourierCharges)}

                    onChange={handleChange}
                  />
                  {error.CourierCharges && (
                    <div style={{ opacity: 1 }}>
                      <small className="error_message">
                        {error.CourierCharges}
                      </small>
                    </div>
                  )}
                </div>
              )}

              <div class={`col-md-6  ${createInfo.inputDisable}`}>
                <label for="netAmount" class="form-label confirm_value ">
                  Net Amount To Pay
                </label>
                <input
                  ref={netAmount_ref}
                  class={`desc_input_text w-100 rounded-2 input-font-size-sm
                    `} //new style added
                  type="text"
                  id="netAmount"
                  name="netAmount"
                  disabled
                  style={{
                    cursor: "not-allowed",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                  placeholder="Enter the new amount to pay"
                  value={
                    // freeBook === 1
                    //   ? 0
                    //   : Number(actualAmountPrice) +
                    //   (initialfields.deliveryMode === 1
                    //     ? courierCharge.length > 0
                    //       ? courierCharge.amount
                    //       : 0
                    //     : 0) -
                    //   (Number(totalFinalPrice) +
                    //     Number(couponApplied.amount) +
                    //     (rewardsnApplied.status ? Number(rewardAmount) : 0))
                    basePrice -
                    (Number(couponApplied.amount) +
                      parseInt(
                        rewardsnApplied.status === true ? rewardAmount : 0
                      ) +
                      Number(totalFinalPrice)) +
                    (freeBook === 1
                      ? 0
                      : paginatedBooks?.length > 0
                      ? (initialfields.deliveryMode == 1 &&
                          courierCharge?.amount) ||
                        0
                      : 0)
                  }
                  onChange={handleChange}
                />
                {error.netAmount && (
                  <small className="error_message">{error.netAmount}</small>
                )}
              </div>
              <div class="col-md-6">
                <label
                  htmlFor="payment_mode"
                  className="form-label confirm_value"
                >
                  Payment Mode
                </label>

                <div>
                  {freeBook === 1 ? (
                    <>
                      <input
                        ref={payment_mode_ref}
                        className={`shadow-none input-font-size ${createInfo.checkbox_radio}`}
                        type="radio"
                        id="payment_mode"
                        name="payment_mode"
                        value={3}
                        checked={initialfields.payment_mode === 3}
                        onChange={handleChange}
                      />
                      <label
                        htmlFor="payment_mode"
                        className={`${createInfo.margin_right} form-label confirm_value me-3`}
                        style={{ verticalAlign: "unset", margin: "0" }}
                      >
                        Free
                      </label>
                    </>
                  ) : (
                    <>
                      <input
                        ref={payment_mode_ref}
                        className={`shadow-none input-font-size ${createInfo.checkbox_radio}`}
                        type="radio"
                        id="payment_mode"
                        name="payment_mode"
                        value={0}
                        checked={initialfields.payment_mode === 0}
                        onChange={handleChange}
                      />
                      <label
                        htmlFor="payment_mode"
                        className={`${createInfo.margin_right} form-label confirm_value me-3`}
                        style={{ verticalAlign: "unset", margin: "0" }}
                      >
                        Cash
                      </label>

                      <input
                        ref={payment_mode_ref}
                        className={`shadow-none input-font-size ${createInfo.checkbox_radio}`}
                        type="radio"
                        id="payment_modeQr"
                        name="payment_mode"
                        value={2}
                        checked={initialfields.payment_mode === 2}
                        onChange={handleChange}
                      />
                      <label
                        htmlFor="payment_modeQr"
                        className="form-label confirm_value"
                        style={{ verticalAlign: "unset", margin: "0" }}
                      >
                        QR Cash
                      </label>
                    </>
                  )}
                </div>
              </div>
            </form>
          </fieldset>
        </div>
        <div className="col-md-12 col-12 ListBtn">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <Link
                to={id ? "javascript:void(0)" : "/ListPurchase"}
                onClick={id ? navigateToPreviousScreen : () => {}}
                className="secondaryButton "
                variant="secondary"
              >
                {id ? "Back to View Course" : "Back to Sales"}
              </Link>
            </li>
            <li class="ListBtnItems">
              {/* <Link
                to="javascript:void(0)"
                onClick={
                  userCheck && selectedBooks.length > 0 ? handleSubmit : null
                }
                className={`primaryButton text-center ${
                  !userCheck || selectedBooks.length === 0 ? "disabledbtn" : ""
                }`}
                disabled={!userCheck || selectedBooks.length === 0}
                variant="primary"
              >
                Save Sales
              </Link> */}
              <Link
                to="javascript:void(0)"
                onClick={
                  userCheck && selectedBooks.length > 0
                    ? // ((initialfields.deliveryMode == 1 && courierCharge !== 0) ||
                      //   (initialfields.deliveryMode == 0 && courierCharge == 0))
                      handleSubmit
                    : undefined
                }
                className={`primaryButton text-center ${
                  !userCheck || selectedBooks.length === 0
                    ? // (initialfields.deliveryMode != 0 && courierCharge === 0)
                      "disabledbtn"
                    : ""
                }`}
                disabled={
                  !userCheck || selectedBooks.length === 0
                  // (initialfields.deliveryMode != 0 && courierCharge === 0)
                }
                variant="primary"
              >
                Save Sales
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
